cb.define(['common/common_VM.Extend.js'], function (common) {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };
    var proMap = {};
    const returnSkuId = "productskus_id";
    const returnSkuCode = "code";
    const returnSkuName = "name";
    const returnSkunums = "amount";
    const returnSkuAvailableNum = "availableNum";
    const returnSkuSpec = "specs";
    const returnProId = "id";
    const returnProCode = "code";
    const returnProName = "cName";
    var PM_pmc_giftpreferential_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var self = this;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var mode = viewmodel.getParams().mode;
            let action = viewmodel.getParams().action;
            var initData = viewmodel.getParams().billData;
            var unit = cb.rest.AppContext.user.currencyName || "元";

            viewmodel.get('cMonthDays').setState('min', 1);
            viewmodel.get('cMonthDays').setState('max', 31);

            viewmodel.get("giftPreferentialStrategy").setState('showRowNo',false);
            viewmodel.on('promotionCheck', function () {
                if (!viewmodel.get('dEndDate').getValue()) {
                    cb.utils.alert('请输入开始时间后检查', 'warning');
                    return false;
                }
                if (!viewmodel.get('dStartDate').getValue() >= viewmodel.get('dEndDate').getValue()) {
                    cb.utils.alert('请输入结束时间后检查', 'warning');
                    return false;
                }
                if (viewmodel.get('dStartDate').getValue() >= viewmodel.get('dEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (viewmodel.get('iDesignatedShop').getValue() == 2) {
                    if (!viewmodel.get('preferentialShop') || viewmodel.get('preferentialShop').getShowValue() == "") {
                        cb.utils.alert('请选择指定店铺后检查', 'warning');
                        return false;
                    }
                }

                if (viewmodel.get('isAllProduct').getValue() == 0) {
                    if (viewmodel.get("iActivityItemType").getValue() == 0) {
                        if (!viewmodel.get('giftPreferentialPro').getRows() || viewmodel.get('giftPreferentialPro').getRows().length < 1) {
                            cb.utils.alert('请选择适用商品后检查', 'warning');
                            return false;
                        } else {
                            for (let i = 0; i < viewmodel.get('giftPreferentialPro').getRows().length; i++) {
                                if (!viewmodel.get('giftPreferentialPro').getRows()[i].iProductId) {
                                    cb.utils.alert('请选择第' + (i + 1) + '行适用商品后检查', 'warning');
                                    return false;
                                }
                            }
                        }
                    } else {
                        if (!viewmodel.get('giftPreferentialClassPro').getShowValue() || viewmodel.get('giftPreferentialClassPro').getShowValue().length < 1) {
                            cb.utils.alert('请选择适用商品类型后检查', 'warning');
                            return false;
                        }
                    }
                }
                var cData = viewmodel.collectData(true);
                if (!cb.utils.isEmpty(cData.iActivityItemType)) {
                    cData.iActivityItemType = Number(cData.iActivityItemType);
                }
                if (!cb.utils.isEmpty(cData.iDesignatedShop)) {
                    cData.iDesignatedShop = Number(cData.iDesignatedShop);
                }
                if (!cb.utils.isEmpty(cData.isAllProduct)) {
                    cData.isAllProduct = Number(cData.isAllProduct);
                }
                var data = {
                    billtype: "VoucherList",
                    billno: 'pmc_promotioncheck',
                    params: {
                        datas: cData
                    }
                };

                cb.loader.runCommandLine('bill', data, viewmodel, (vm) => {
                    vm.on('promotionchecksure', function () {
                        vm.execute("close");
                    });
                    vm.on("close", function () {
                        viewmodel.communication({
                            type: 'modal',
                            payload: {
                                data: false
                            }
                        })
                    });
                    return true;
                });
            })

            const iGiftItemTypeArray =
                [{
                    "value": "1",
                    "text": "送指定数量赠品",
                    "nameType": "text"
                },
                    {
                        "value": "2",
                        "text": "送优惠券",
                        "nameType": "text"
                    },
                    {
                        "value": "3",
                        "text": "送指定数量积分",
                        "nameType": "text"
                    },
                    {
                        "value": "4",
                        "text": "N倍积分",
                        "nameType": "text"
                    },
                    {
                        "value": "5",
                        "text": "送指定金额赠品",
                        "nameType": "text"
                    }];

            const isAllMemberLeveArray =
                [{
                    "value": "1",
                    "text": "全部买家",
                    "nameType": "text"
                },
                    {
                        "value": "2",
                        "text": "全部会员",
                        "nameType": "text"
                    },
                    {
                        "value": "0",
                        "text": "指定会员等级",
                        "nameType": "text"
                    }];

            const displayReferType = (viewmodel, value) => {
                var refCode = "";
                var refRetId = "";
                //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                if (value == 1) {
                    refCode = "pc_presentationclassref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 2) {
                    refCode = "pc_producttplref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 3) {
                    refCode = "pc_brandref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 4) {
                    refCode = "pc_tagref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                }
                if (refCode) {
                    viewmodel.get("giftPreferentialClassPro").setRefCode(refCode, refRetId);
                }
            }

            //btnAddRow1 额外商品的增行
            //table表数据所有的setVisible true是false, false是true(除按钮外)
            const displaybException = (viewmodel) => {
                if (viewmodel.get('bExceptionalProduct').getValue() && viewmodel.get('bExceptionalProduct').getValue() == 1) {
                    if (viewmodel.getParams().mode != 'browse') {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodtab',
                            visible: true
                        });
                    }
                    viewmodel.get('giftPreferentialExceptionPro').setVisible(false);
                    // if (mode != "browse") {
                    //     viewmodel.get('btnAddRow1').setVisible(true);
                    // }
                } else {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodtab',
                        visible: false
                    });
                    viewmodel.get('giftPreferentialExceptionPro').setVisible(true);
                    // if (mode != "browse") {
                    //     viewmodel.get('btnAddRow1').setVisible(false);
                    // }
                }
            }

            const displayisSpreadCode = () => {
                if (viewmodel.get("isSpreadCode").getValue() && viewmodel.get("isSpreadCode").getValue() == 1) {
                    viewmodel.get('giftPreferentialSpread').setVisible(true);
                } else {
                    viewmodel.get('giftPreferentialSpread').setVisible(false);
                }
            }

            const displayiActivityItemType = (viewmodel) => {
                if (viewmodel.get('iActivityItemType').getValue() == 0) {
                    if (viewmodel.getParams().mode != 'browse') {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                    }
                    if (viewmodel.get('isAllProduct').getValue() == 0) {
                        viewmodel.get('bExceptionalProduct').setValue(0);
                        viewmodel.get('bExceptionalProduct').setVisible(false);
                    }
                    viewmodel.get('giftPreferentialClassPro').setVisible(false);
                    viewmodel.get('giftPreferentialPro').setVisible(false);

                } else {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('bExceptionalProduct').setVisible(true);

                    viewmodel.get('giftPreferentialClassPro').setVisible(true);
                    viewmodel.get('giftPreferentialPro').setVisible(true);
                }
                displaybException(viewmodel);
            }

            const displayisShare = () => {
                let isShare = viewmodel.get('isShare').getValue();
                if (isShare == 0) {
                    viewmodel.get('isTakeInShare').setDisabled(true);
                    viewmodel.get('isTakeInShare').setValue(0);
                } else {
                    viewmodel.get('isTakeInShare').setDisabled(false);
                }
            }
            //add by shuzhana 买赠活动启用后不允许编辑
            const displayForbidden = (viewmodel) => {
                if (viewmodel.get('bApplyOMCChannel').getValue() && viewmodel.getParams().mode == 'edit' && viewmodel.get('iValid').getValue() == '1') {

                    viewmodel.setReadOnly(true);
                    viewmodel.get('btnBatchOp').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(false);
                    viewmodel.get('remarkKeywordsImport').setVisible(false);
                    viewmodel.get('remarkKeywordsMouldDownload').setVisible(false);
                    let gridModel = viewmodel.get('giftPreferentialPro');
                    let actions = gridModel.getCache('actions');
                    let rows = viewmodel.get("giftPreferentialPro").getRows();
                    let actionsStates = [];
                    rows.forEach(data => {
                        let actionState = {};
                        actions.forEach(action => {
                            if (action.cItemName == "btnDeleteRow") {
                                actionState[action.cItemName] = {visible: false};
                            }
                        });
                        actionsStates.push(actionState);
                    });
                    gridModel.setActionsState(actionsStates);
                    common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
                }
            }

          //活动方式控制事件
          viewmodel.get('activityMode').on('afterValueChange', function (data) {
            common.displayActivityMode(viewmodel);
          });

          const displayActivityMode = (applicableChannel) => {
            var visibleFlag = false;
            if (applicableChannel){
              if (applicableChannel.indexOf("1") > -1){
                viewmodel.get('activityMode').setVisible(true);
                visibleFlag = true;
              }else {
                viewmodel.get('activityMode').setVisible(false);
              }
            }else{
              viewmodel.get('activityMode').setVisible(false);
            }
            displayActivityModeDetail(visibleFlag);
          }

          const displayActivityModeDetail = (visibleFlag) => {
            if (visibleFlag){
              common.displayActivityMode(viewmodel);
            }else{
              viewmodel.get('beginTime').setVisible(false);
              viewmodel.get('endTime').setVisible(false);
              viewmodel.get('cWeekDays').setVisible(false);
              viewmodel.get('cWeekBeginTime').setVisible(false);
              viewmodel.get('cWeekEndTime').setVisible(false);
              viewmodel.get('cMonthDays').setVisible(false);
              viewmodel.get('cMonthBeginTime').setVisible(false);
              viewmodel.get('cMonthEndTime').setVisible(false);
            }
          }

            const displayisAllProduct = (viewmodel) => {
                if (viewmodel.get('isAllProduct').getValue() == 1) {
                    viewmodel.get('iExtended').setVisible(false);
                    viewmodel.get('iExtended').setValue(false);
                    viewmodel.get('iActivityItemType').setValue(0);
                    viewmodel.get('iActivityItemType').setVisible(false);
                    let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                    let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0) {
                        viewmodel.get('bExceptionalProduct').setVisible(true);
                    } else {
                        viewmodel.get('bExceptionalProduct').setVisible(false);
                    }

                    displayExtended();
                    displayiActivityItemType(viewmodel);
                    displaybException(viewmodel);

                    viewmodel.get('giftPreferentialPro').setVisible(true);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });

                } else {
                    let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                    let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    let iGiftType = viewmodel.get('iGiftType').getValue();
                    if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0 && iGiftType != 4 && iGiftType != 5) {
                        viewmodel.get('iExtended').setVisible(true);
                    } else {
                        viewmodel.get('iExtended').setVisible(false);
                        viewmodel.get('iExtended').setValue(false);
                    }
                    viewmodel.get('iActivityItemType').setVisible(true);

                    displayExtended();
                    displayiActivityItemType(viewmodel);
                    displaybException(viewmodel);
                }
            }

            const displayExtended = () => {
                let iExtended = viewmodel.get('iExtended').getValue();
                if (!iExtended) {
                    viewmodel.get('iExtendedRule').setValue(2);
                    viewmodel.get("iSpecies").setValue(2);
                }
                viewmodel.get('iExtendedRule').setVisible(iExtended);
                viewmodel.get("iSpecies").setVisible(iExtended);
            }

            const displayiDesignatedShop = () => {
                let iDesignatedShop = viewmodel.get('iDesignatedShop').getValue();
                if (iDesignatedShop == 2) {
                    viewmodel.get('preferentialShop').setVisible(true);
                } else {
                    viewmodel.get('preferentialShop').setVisible(false);
                    if (viewmodel.get('preferentialShop').getValue()) {
                        viewmodel.get('preferentialShop').setValue([]);
                    }
                }
            }

            const displayMustBuyPro = (viewmodel) => {
                let bMustBuyPro = viewmodel.get('bMustBuyProduct').getValue();
                let isShow = (bMustBuyPro == 1);
                // viewmodel.get('giftPreferentialMustBuyPro').setVisible(isShow);
                viewmodel.execute('updateViewMeta', {
                    code: 'mustbuyprotab',
                    visible: isShow
                });
                if (!isShow) {
                    delMustBuyPro();
                }
            }

            viewmodel.get('bMustBuyProduct').on('afterValueChange', function (data) {
                displayMustBuyPro(viewmodel);
            });

            // const displayOfflineStore = () => {
            //     if (viewmodel.get('promotionParams')) {
            //         let userType = viewmodel.get('promotionParams').userType;
            //         //超级管理员
            //         if (userType != 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
            //             if (viewmodel.get('offLineStore').getValue() == 1) {
            //                 viewmodel.get('offLineStore').setValue(2);
            //             }
            //             let auditStatusModel = viewmodel.get('offLineStore');
            //             let dataSource = auditStatusModel.getState('dataSource');
            //             let newSource = [];
            //             dataSource && dataSource.forEach(data => {
            //                 //置灰全部门店  data.value为1
            //                 newSource.push({value: data.value, nameType: 'text', text: data.text, disabled: data.value == 1});
            //             });
            //             auditStatusModel.setDataSource(newSource);
            //         }
            //     }
            //     let offLineStore = viewmodel.get('offLineStore').getValue();
            //     if (offLineStore == 2) {
            //         viewmodel.get('giftPreferentialStore').setVisible(true);
            //     } else {
            //         viewmodel.get('giftPreferentialStore').setVisible(false);
            //     }
            // }

            const delPro = () => {
                if (viewmodel.get('giftPreferentialPro').getRows() && viewmodel.get('giftPreferentialPro').getRows().length > 0) {
                    let pricenums = viewmodel.get('giftPreferentialPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('giftPreferentialPro').deleteRows(i);
                    }
                }
            }

            const delClassPro = () => {
                if (viewmodel.get('giftPreferentialClassPro').getShowValue() && viewmodel.get('giftPreferentialClassPro').getShowValue().length > 0) {
                    viewmodel.get('giftPreferentialClassPro').setValue([]);
                }
            }

            const delExceptionPro = () => {
                if (viewmodel.get('giftPreferentialExceptionPro').getRows() && viewmodel.get('giftPreferentialExceptionPro').getRows().length > 0) {
                    let expricenum = viewmodel.get('giftPreferentialExceptionPro').getRowsCount();
                    for (let j = expricenum - 1; j >= 0; j--) {
                        viewmodel.get('giftPreferentialExceptionPro').deleteRows(j);
                    }
                }
            }

            const delMustBuyPro = () => {
                if (viewmodel.get('giftPreferentialMustBuyPro').getData() && viewmodel.get('giftPreferentialMustBuyPro').getData().length > 0) {
                    let pricenums = viewmodel.get('giftPreferentialMustBuyPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('giftPreferentialMustBuyPro').deleteRows(i);
                    }
                }
            }

            //清除商品/sku数据
            const delItemPro = (model, rowIndex) => {
                model.setCellValue(rowIndex, 'sgiftids', null, true);
                model.setCellValue(rowIndex, 'sgiftcodes', null, true);
                model.setCellValue(rowIndex, 'sgiftnames', null, true);

                model.setCellValue(rowIndex, 'sGiftSkuIds', null, true);
                model.setCellValue(rowIndex, 'sGiftSkuCodes', null, true);
                model.setCellValue(rowIndex, 'sGiftSkuNames', null, true);
                model.setCellValue(rowIndex, 'skuDescribe', null, true);
            }

            //清除优惠券数据
            const delItemCoupon = (model, rowIndex) => {
                model.setCellValue(rowIndex, 'couponids', null, true);
                model.setCellValue(rowIndex, 'couponnames', null, true);
                model.setCellValue(rowIndex, 'couponnums', null, true);
            }

            const delItem = (model, rowIndex) => {
                delItemPro(model, rowIndex);
                delItemCoupon(model, rowIndex);
            }

            const delStrategyList = () => {
                let giftPreferentialStrategyList = viewmodel.get("giftPreferentialStrategy").getRows();
                //切换活动类型时 只保留第一个策略，删除所有孙表行数据
                if (giftPreferentialStrategyList && giftPreferentialStrategyList.length > 0) {
                    var rowIndexes = [];
                    for (let i = giftPreferentialStrategyList.length - 1; i > 0; i--) {
                        rowIndexes.push(i);
                    }
                    viewmodel.get("giftPreferentialStrategy").deleteRows(rowIndexes);
                    delSunTable(0);
                }
            }

            const displayiAreaId = (viewmodel) => {
                delPro();
                delClassPro();
                delExceptionPro();
                delMustBuyPro();
                delStrategyList;
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    viewmodel.get('btnImport').setVisible(true);
                    viewmodel.get('btnExport').setVisible(true);
                    // viewmodel.get('btnBatchOp').setVisible(true);
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }

            //用于编辑时设置行状态
            const displayItemCellState = (itemModel, itemData, rowIndex) => {
                if (itemData.iGiftItemType == 1) {//送指定数量赠品
                    itemModel.setCellState(rowIndex, 'icapping', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'dToplimit', 'disabled', itemData.icapping == 0 ? true : false);
                    itemModel.setCellState(rowIndex, 'iGiftNum', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'sgiftnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sGiftSkuNames', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'couponnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'warehouseName', 'disabled', false);
                } else if (itemData.iGiftItemType == 2) {//送优惠券
                    itemModel.setCellState(rowIndex, 'icapping', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'dToplimit', 'disabled', itemData.icapping == 0 ? true : false);
                    itemModel.setCellState(rowIndex, 'iGiftNum', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sgiftnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sGiftSkuNames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'couponnames', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'warehouseName', 'disabled', true);
                } else if (itemData.iGiftItemType == 3) {//送积分
                    itemModel.setCellState(rowIndex, 'icapping', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'dToplimit', 'disabled', itemData.icapping == 0 ? true : false);
                    itemModel.setCellState(rowIndex, 'iGiftNum', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'sgiftnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sGiftSkuNames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'couponnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'warehouseName', 'disabled', true);
                } else if (itemData.iGiftItemType == 4) {//N倍积分
                    itemModel.setCellState(rowIndex, 'icapping', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'dToplimit', 'disabled', itemData.icapping == 0 ? true : false);
                    itemModel.setCellState(rowIndex, 'iGiftNum', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'sgiftnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sGiftSkuNames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'couponnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'warehouseName', 'disabled', true);
                } else if (itemData.iGiftItemType == 5) {//送指定金额赠品
                    itemModel.setCellState(rowIndex, 'icapping', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'dToplimit', 'disabled', itemData.icapping == 0 ? true : false);
                    itemModel.setCellState(rowIndex, 'iGiftNum', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'sgiftnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'sGiftSkuNames', 'disabled', false);
                    itemModel.setCellState(rowIndex, 'couponnames', 'disabled', true);
                    itemModel.setCellState(rowIndex, 'warehouseName', 'disabled', false);
                }
            }
            //用于item赠送类型变化
            const displayGiftItemType = (itemModel, itemData, rowIndex) => {
                if (itemData.iGiftItemType == 1) {//送指定数量赠品
                    delItem(itemModel, rowIndex);

                    itemModel.setCellValue(rowIndex, 'iGiftNum', null, true);
                    itemModel.setCellValue(rowIndex, 'icapping', 0, true);
                    itemModel.setCellValue(rowIndex, 'dToplimit', null, true);
                } else if (itemData.iGiftItemType == 2) {//送优惠券
                    delItemPro(itemModel, rowIndex);
                    delItemCoupon(itemModel, rowIndex);

                    itemModel.setCellValue(rowIndex, 'iGiftNum', null, true);
                    itemModel.setCellValue(rowIndex, 'icapping', 0, true);
                    itemModel.setCellValue(rowIndex, 'dToplimit', null, true);
                } else if (itemData.iGiftItemType == 3) {//送积分
                    delItemPro(itemModel, rowIndex);
                    delItemCoupon(itemModel, rowIndex);

                    itemModel.setCellValue(rowIndex, 'iGiftNum', null, true);
                    itemModel.setCellValue(rowIndex, 'icapping', 0, true);
                    itemModel.setCellValue(rowIndex, 'dToplimit', null, true);
                } else if (itemData.iGiftItemType == 4) {//N倍积分
                    delItemPro(itemModel, rowIndex);
                    delItemCoupon(itemModel, rowIndex);

                    itemModel.setCellValue(rowIndex, 'iGiftNum', null, true);
                    itemModel.setCellValue(rowIndex, 'icapping', 0, true);
                    itemModel.setCellValue(rowIndex, 'dToplimit', null, true);
                } else if (itemData.iGiftItemType == 5) {//送指定金额赠品
                    delItemPro(itemModel, rowIndex);
                    delItemCoupon(itemModel, rowIndex);

                    itemModel.setCellValue(rowIndex, 'iGiftNum', null, true);
                    itemModel.setCellValue(rowIndex, 'icapping', 0, true);
                    itemModel.setCellValue(rowIndex, 'dToplimit', null, true);
                }
                displayItemCellState(itemModel, itemData, rowIndex);
            }

            const displayGiftType = (iGiftType, editRowModel) => {
                viewmodel.get('applicableChannel').setDisabled(false);
                viewmodel.get('isAllMemberLeve').setDisabled(false);
                viewmodel.get('remarkType').setVisible(false);
                viewmodel.get('remarkKeywords').setVisible(false);
                viewmodel.get('remarkKeywordsImport').setVisible(false);
                viewmodel.get('remarkKeywordsMouldDownload').setVisible(false);

                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                let onlyOMC = (applyOnlineChannel == 0 && applyOffLineChannel == 0 && bApplyOMCChannel == 1);
                let onlyOffLine = (applyOnlineChannel == 0 && applyOffLineChannel == 1 && bApplyOMCChannel == 0);
                if (onlyOMC) {
                    editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bShowIt", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("dRemainingAvailableNum", "bShowIt", true);
                    if (iGiftType != 4) {
                        editRowModel.get("iSendGiftWay").setVisible(true);
                    } else {
                        editRowModel.get("iSendGiftWay").setVisible(false);
                    }
                } else {
                    editRowModel.get("iSendGiftWay").setVisible(false);
                    editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bShowIt", false);
                    editRowModel.get("giftPreferentialItem").setColumnState("dRemainingAvailableNum", "bShowIt", false);
                }
                /**
                 * 活动类型     满额送 1     满件送2     买就送3     买A送A  4  按关键词送  5
                 */
                editRowModel.get('dConsumerSpending').setState("after", iGiftType == 1 || iGiftType == 3 || iGiftType == 5 ? unit : "件");
                if (iGiftType == 1) {
                    if (viewmodel.getParams().mode != "browse") {
                        editRowModel.get('btnAddRow3').setVisible(true);
                        editRowModel.get('btnDeleteRow3').setVisible(true);
                    }
                    viewmodel.get("isAllProduct").setVisible(true);
                    displayisAllProduct(viewmodel);
                    editRowModel.get('dConsumerSpending').setVisible(true);
                    editRowModel.get('dConsumerSpendingItem').setVisible(false);
                    if (onlyOMC) {
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", false);
                    } else {
                        if (onlyOffLine) {
                            viewmodel.get('bCrossRegionSelect').setVisible(true);
                        } else {
                            viewmodel.get('bCrossRegionSelect').setValue(0);
                            viewmodel.get('bCrossRegionSelect').setVisible(false);
                        }
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", true);
                    }
                    editRowModel.get("giftPreferentialItem").setColumnState("iGiftItemType", "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sGiftSkuNames', "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sgiftnames', "disabled", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iConsumerSpending", "visible", false);
                } else if (iGiftType == 2) {
                    if (viewmodel.getParams().mode != "browse") {
                        editRowModel.get('btnAddRow3').setVisible(true);
                        editRowModel.get('btnDeleteRow3').setVisible(true);
                    }
                    viewmodel.get("isAllProduct").setVisible(true);
                    displayisAllProduct(viewmodel);
                    editRowModel.get('dConsumerSpending').setVisible(true);
                    editRowModel.get('dConsumerSpendingItem').setVisible(false);
                    if (onlyOMC) {
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", false);
                    } else {
                        if (onlyOffLine) {
                            viewmodel.get('bCrossRegionSelect').setVisible(true);
                        } else {
                            viewmodel.get('bCrossRegionSelect').setValue(0);
                            viewmodel.get('bCrossRegionSelect').setVisible(false);
                        }
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", true);
                    }

                    editRowModel.get("giftPreferentialItem").setColumnState("iGiftItemType", "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sGiftSkuNames', "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sgiftnames', "disabled", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iConsumerSpending", "visible", false);
                } else if (iGiftType == 3 || iGiftType == 5) {
                    editRowModel.get('btnAddRow3').setVisible(false);
                    editRowModel.get('btnDeleteRow3').setVisible(false);
                    if (applyOnlineChannel == 0 && applyOffLineChannel == 0 && bApplyOMCChannel == 1) {
                        editRowModel.get('dConsumerSpendingItem').setVisible(true);
                        editRowModel.get('dConsumerSpending').setVisible(true);
                    } else {
                        editRowModel.get('dConsumerSpendingItem').setVisible(false);
                        editRowModel.get('dConsumerSpending').setVisible(false);
                    }
                    viewmodel.get("isAllProduct").setVisible(true);
                    displayisAllProduct(viewmodel);
                    if (onlyOMC) {
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", false);
                    } else {
                        editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", true);
                    }
                    viewmodel.get('bCrossRegionSelect').setValue(0);
                    viewmodel.get('bCrossRegionSelect').setVisible(false);
                    editRowModel.get("giftPreferentialItem").setColumnState('icapping', "visible", false);
                    editRowModel.get("giftPreferentialItem").setColumnState('dToplimit', "visible", false);
                    editRowModel.get("giftPreferentialItem").setColumnState("iGiftItemType", "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sGiftSkuNames', "visible", true);
                    editRowModel.get("giftPreferentialItem").setColumnState('sgiftnames', "disabled", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iConsumerSpending", "visible", false);
                    if (iGiftType == 5) {
                        viewmodel.get('applicableChannel').setDisabled(true);
                        //viewmodel.get('isAllMemberLeve').setDisabled(true);
                        viewmodel.get('remarkType').setVisible(true);
                        viewmodel.get('remarkKeywords').setVisible(true);
                        if (viewmodel.getParams().mode != "browse") {
                            viewmodel.get('remarkKeywordsImport').setVisible(true);
                            viewmodel.get('remarkKeywordsMouldDownload').setVisible(true);
                        }
                    }
                } else if (iGiftType == 4) {
                    editRowModel.get('btnAddRow3').setVisible(false);
                    editRowModel.get('btnDeleteRow3').setVisible(false);
                    viewmodel.get("isAllProduct").setVisible(false);
                    viewmodel.get("isAllProduct").setValue(0);
                    displayisAllProduct(viewmodel);
                    viewmodel.get('bCrossRegionSelect').setVisible(false);
                    viewmodel.get('bCrossRegionSelect').setValue(0);
                    editRowModel.get('dConsumerSpending').setVisible(false);
                    editRowModel.get('dConsumerSpendingItem').setVisible(false);
                    editRowModel.get("giftPreferentialItem").setColumnState("iGiftItemType", "visible", false);
                    editRowModel.get("giftPreferentialItem").setColumnState('couponnames', "visible", false);
                    editRowModel.get("giftPreferentialItem").setColumnState('sGiftSkuNames', "visible", false);
                    editRowModel.get("giftPreferentialItem").setColumnState('sgiftnames', "disabled", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iConsumerSpending", "visible", true);
                }
            }

            const displayStrategy = (editRowModel) => {
                editRowModel.get('giftPreferentialItem').setState('showColumnSetting', false);
                editRowModel.get('dConsumerSpending').setState('min', 0);
                editRowModel.get('dConsumerSpendingItem').setState('min', 0);
                editRowModel.get("giftPreferentialItem").getEditRowModel().get('iGiftNum').setState('min', 0);
                let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                let giftPreferentialItem = editRowModel.get("giftPreferentialItem");
                let sGiftSkuNames = giftPreferentialItem.getEditRowModel().get('sGiftSkuNames');
                let iGiftType = viewmodel.get('iGiftType').getValue();
                let itemList = giftPreferentialItem.getRows();
                let iSendGiftWay = editRowModel.get('iSendGiftWay').getValue();
                if (bApplyOMCChannel == 1) {
                    editRowModel.get("giftPreferentialItem").setColumnState("warehouseName", "bShowIt", true);
                    if (iGiftType == 4) {
                        editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "bShowIt", false);
                    } else {
                        if (applyOnlineChannel == 0 && applyOffLineChannel == 0) {
                            if (iSendGiftWay == 1) {
                                editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "bShowIt", true);
                            } else {
                                editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "bShowIt", false);
                            }
                        } else {
                            editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "bShowIt", true);
                        }
                    }
                    let auditStatusModel = editRowModel.get('giftPreferentialItem').getEditRowModel().get('iGiftItemType');
                    let newSource = [];
                    iGiftItemTypeArray && iGiftItemTypeArray.forEach(data => {
                        if (data.value == 1) {
                            newSource.push({
                                value: data.value,
                                nameType: 'text',
                                text: data.text
                            });
                        }
                    });
                    auditStatusModel.setDataSource(newSource);
                } else {
                    editRowModel.get("giftPreferentialItem").setColumnState("warehouseName", "bShowIt", false);
                    editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "bShowIt", false);
                    if (iGiftType == 3 || iGiftType == 5) {
                        let auditStatusModel = editRowModel.get('giftPreferentialItem').getEditRowModel().get('iGiftItemType');
                        let newSource = [];
                        iGiftItemTypeArray && iGiftItemTypeArray.forEach(data => {
                            if (data.value != 3) {
                                newSource.push({
                                    value: data.value,
                                    nameType: 'text',
                                    text: data.text
                                });
                            }
                        });
                        auditStatusModel.setDataSource(newSource);
                    } else {
                        let auditStatusModel = editRowModel.get('giftPreferentialItem').getEditRowModel().get('iGiftItemType');
                        auditStatusModel.setDataSource(iGiftItemTypeArray);
                    }

                }

                for (let i = 0; i < itemList.length; i++) {
                    displayItemCellState(giftPreferentialItem, itemList[i], i);
                }

                if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0) {
                    editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bShowIt", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("dRemainingAvailableNum", "bShowIt", true);
                } else {
                    editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bShowIt", false);
                    editRowModel.get("giftPreferentialItem").setColumnState("dRemainingAvailableNum", "bShowIt", false);
                }
                giftPreferentialItem.on('beforeInsertRowsFromRefer', function (data) {
                    let newData = proMap[data.index];
                    var row = {};
                    if (newData) {
                        let nameKey = data.columnName;
                        let idKey = "sgiftids";
                        let code = "sgiftcodes";
                        let describe = "skuDescribe";
                        let returnIdKey = returnSkuId;
                        let returnCodeKey = returnSkuCode;
                        let returnNameKey = returnSkuName;
                        let returnDecKey = returnSkuSpec;
                        //商品
                        if (data.columnName == 'sgiftnames') {
                        } else {
                            idKey = "sGiftSkuIds";
                            code = "sGiftSkuCodes";
                        }
                        row[code] = "";
                        row[idKey] = "";
                        row[nameKey] = "";
                        for (let i = 0; i < newData.length; i++) {
                            if (newData[i][returnIdKey] && newData[i][returnIdKey] != "") {
                                row[idKey] += newData[i][returnIdKey];
                                if (i != newData.length - 1)
                                    row[idKey] += ",";
                            }
                            if (newData[i][returnNameKey] && newData[i][returnNameKey] != "") {
                                row[nameKey] += newData[i][returnNameKey];
                                if (newData[i][returnDecKey] && newData[i][returnDecKey] != "") {
                                    row[nameKey] += "(" + newData[i][returnDecKey] + ")";
                                }
                                if (i != newData.length - 1)
                                    row[nameKey] += ",";
                            }
                            if (newData[i][returnCodeKey] && newData[i][returnCodeKey] != "") {
                                row[code] += newData[i][returnCodeKey];
                                if (i != newData.length - 1)
                                    row[code] += ",";
                            }
                        }
                        data.rows.length = 0;
                        data.rows.push(row);
                    }
                })
                giftPreferentialItem.on("beforeBrowse", function (data) {
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    let rowIndex = data.rowIndex;
                    let banProducts = "";
                    let banSkus = "";
                    let preferentialProList = editRowModel.get('giftPreferentialItem').getRows();
                    let currentPreferentialPro = preferentialProList[rowIndex].sgiftcodes;
                    let currentPreferentialProSku = preferentialProList[rowIndex].sGiftSkuCodes;
                    //sku参照
                    if (data && data.cellName == 'sGiftSkuNames') {
                        // 当前行已经选了sku
                        if (currentPreferentialProSku && currentPreferentialProSku != '') {
                            condition.simpleVOs.push({
                                field: 'code',
                                op: 'in',
                                value1: currentPreferentialProSku.split(',')
                            });
                        } else {
                            //排除当前行选择的商品的sku
                            if (currentPreferentialPro && currentPreferentialPro != '') {
                                // condition.simpleVOs.push({
                                //     field: 'productId.code',
                                //     op: 'in',
                                //     value1: currentPreferentialPro.split(',')
                                // });
                                // condition.simpleVOs.push({
                                //     field: 'productId.code',
                                //     op: 'nin',
                                //     value1: currentPreferentialPro.split(',')
                                // });
                                banProducts += currentPreferentialPro;
                            }
                            //排除其他行选择的商品和sku
                            for (let i = 0; i < preferentialProList.length; i++) {
                                if (i == rowIndex) {
                                    continue;
                                }
                                //其他行选择了sku
                                if (preferentialProList[i].sGiftSkuCodes && preferentialProList[i].sGiftSkuCodes != '') {
                                    if (banSkus != '' && i < preferentialProList.length - 1) {
                                        banSkus += ",";
                                        banSkus += preferentialProList[i].sGiftSkuCodes;
                                    } else {
                                        banSkus += preferentialProList[i].sGiftSkuCodes;
                                    }
                                }
                                // 其他行选择了商品
                                // if (preferentialProList[i].sgiftcodes && preferentialProList[i].sgiftcodes != '') {
                                //   if (banProducts != '' && i < preferentialProList.length - 1) {
                                //     banProducts += ",";
                                //     banProducts += preferentialProList[i].sgiftcodes;
                                //   } else {
                                //     banProducts += preferentialProList[i].sgiftcodes;
                                //   }
                                // }
                            }
                        }
                        let areaId;
                        if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                            if (!viewmodel.get("iAreaId").getValue()) {
                                cb.utils.alert('请选择适用区域', 'warning');
                                return false;
                            } else {
                                areaId = viewmodel.get("iAreaId").getValue();
                            }
                        }
                        if (areaId) {
                            let externalData = {"areaId": areaId};
                            if (data.context) {
                                data.context.setState('externalData', externalData);
                            } else {
                                data.setState('externalData', externalData);
                            }
                        }
                        common.addProductReferCondition(viewmodel, true, condition, banProducts == "" ? null : banProducts.split(","),
                            banSkus == "" ? null : banSkus.split(","), false);
                    } else if (data.cellName == 'sgiftnames') {
                        //商品参照
                        //当前行选了商品
                        // if (currentPreferentialPro && currentPreferentialPro != '') {
                        //     condition.simpleVOs.push({
                        //         field: 'code',
                        //         op: 'in',
                        //         value1: currentPreferentialPro.split(',')
                        //     });
                        // } else {
                        //     //排除当前行选择的sku
                        //     // if (currentPreferentialProSku && currentPreferentialProSku != '') {
                        //     //     banSkus += currentPreferentialProSku;
                        //     // }
                        //     //当前行没有选择商品，需要排除其他行选择的商品
                        //     for (let i = 0; i < preferentialProList.length; i++) {
                        //         if (i == rowIndex) {
                        //             continue;
                        //         }
                        //         if (preferentialProList[i].sgiftcodes && preferentialProList[i].sgiftcodes != '') {
                        //             if (i > 0) {
                        //                 banProducts += ",";
                        //                 banProducts += preferentialProList[i].sgiftcodes;
                        //             } else {
                        //                 banProducts += preferentialProList[i].sgiftcodes;
                        //             }
                        //         }
                        //     }
                        // }
                        common.addProductReferCondition(viewmodel, false, condition, banProducts == ""
                            ? null : banProducts.split(","), null, false);
                    } else if (data.cellName == 'warehouseName') {
                        condition.simpleVOs.push({
                            field: 'eStore',
                            op: 'eq',
                            value1: 1
                        });
                    }
                    data.context.setFilter(condition);
                    return true;
                })
                sGiftSkuNames.on('afterBrowse', () => {
                    let vm = sGiftSkuNames.getCache('vm');
                    let refGridModel = vm.get('table');
                    refGridModel.setState('rowKeyField', 'productskus_id');
                    let preferentialProList = giftPreferentialItem.getRows();
                    var focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();

                    var currentPreferentialPro = preferentialProList[focusedRowIndex];
                    var skuids = currentPreferentialPro.sGiftSkuIds ? currentPreferentialPro.sGiftSkuIds.split(',') : [];
                    var skucodes = currentPreferentialPro.sGiftSkuCodes ? currentPreferentialPro.sGiftSkuCodes.split(',') : [];
                    var skunames = currentPreferentialPro.sGiftSkuNames ? currentPreferentialPro.sGiftSkuNames.split(',') : [];
                    var pros = [];
                    for (let i = 0; i < skuids.length; i++) {
                        let newobj = {};
                        newobj[returnSkuId] = skuids[i];
                        newobj[returnSkuCode] = skucodes[i];
                        newobj[returnSkuName] = skunames[i];
                        pros.push(newobj);
                    }
                    proMap[focusedRowIndex] = pros;

                    refGridModel.un('afterSetDataSource');
                    refGridModel.un('beforeUnselect');
                    refGridModel.un('beforeSelect');
                    refGridModel.un('beforeSelectAll');
                    refGridModel.un('beforeUnselectAll');

                    refGridModel.on('afterSetDataSource', data => {
                        let selectIndexes = [];
                        // data.forEach((row, index) => {
                        //   // let i = cacheCodesMap[focusedRowIndex].findIndex(item => {
                        //   //   return row.code == item;
                        //   // });
                        //     let i = cacheCodesMap[focusedRowIndex].findIndex(item => {
                        //       return row.code == item;
                        //     });
                        //   if (i != -1) selectIndexes.push(index);
                        // });
                        data.forEach((row, index) => {
                            // let i = cacheCodesMap[focusedRowIndex].findIndex(item => {
                            //   return row.code == item;
                            // });
                            let i = proMap[focusedRowIndex].findIndex(item => {
                                return row.code == item.code;
                            });
                            if (i != -1) selectIndexes.push(index);
                        });
                        refGridModel.select(selectIndexes);
                        let condition = {
                            "isExtend": true,
                            simpleVOs: []
                        };
                        let rowIndex = giftPreferentialItem.getFocusedRowIndex();
                        let banProducts = "";
                        let banSkus = "";
                        let preferentialProList = editRowModel.get('giftPreferentialItem').getRows();
                        //排除其他行选择的商品和sku
                        for (let i = 0; i < preferentialProList.length; i++) {
                            if (i == rowIndex) {
                                continue;
                            }
                            //其他行选择了sku
                            if (preferentialProList[i].sGiftSkuCodes && preferentialProList[i].sGiftSkuCodes != '') {
                                if (banSkus != '' && i < preferentialProList.length - 1) {
                                    banSkus += ",";
                                    banSkus += preferentialProList[i].sGiftSkuCodes;
                                } else {
                                    banSkus += preferentialProList[i].sGiftSkuCodes;
                                }
                            }
                        }
                        common.addProductReferCondition(viewmodel, true, condition, banProducts == "" ? null : banProducts.split(","),
                            banSkus == "" ? null : banSkus.split(","), false);
                        // sGiftSkuNames.setFilter(condition);
                        let params = vm.getParams();
                        if (params.where && params.where.filter)
                            vm.getParams().where.filter = condition;
                    });
                    refGridModel.on('beforeUnselect', indexes => {
                        cacheCodesMapFunction(refGridModel, focusedRowIndex, indexes, false);
                    });
                    refGridModel.on('beforeSelect', indexes => {
                        cacheCodesMapFunction(refGridModel, focusedRowIndex, indexes, true);
                    });
                    refGridModel.on('beforeSelectAll', args => {
                        cacheCodesMapFunction(refGridModel, focusedRowIndex, null, true, true);
                    });
                    refGridModel.on('beforeUnselectAll', args => {
                        cacheCodesMapFunction(refGridModel, focusedRowIndex, null, false, true);
                    });
                });
                giftPreferentialItem.on('afterCellValueChange', function (data) {
                    if (data.cellName == 'icapping') {
                        if (data.value.value == 0 || data.value == 0) {
                            this.setCellValue(data.rowIndex, 'dToplimit', null, true);
                            this.setCellState(data.rowIndex, 'dToplimit', 'disabled', true);
                        } else {
                            this.setCellState(data.rowIndex, 'dToplimit', 'disabled', false);
                        }
                    }
                    //赠送类型  买A赠A -1 送指定数量赠品 1 送优惠券 2 送积分 3 N倍积分 4 送指定金额赠品 5
                    if (data.cellName == "iGiftItemType") {
                        let itemData = giftPreferentialItem.getRow(data.rowIndex);
                        displayGiftItemType(this, itemData, data.rowIndex);
                    }
                })
                giftPreferentialItem.getEditRowModel().get('couponnames').setState('selfDefineClick', function () {
                    var itemIndex = editRowModel.get('giftPreferentialItem').getFocusedRowIndex();
                    var giftPreferentialItem = editRowModel.get('giftPreferentialItem').getRows();
                    var data = {
                        billtype: 'VoucherList',
                        billno: 'pmc_couponref',
                        params: {
                            couponids: "",
                            couponnames: "",
                            couponnums: ""
                        }
                    };
                    if (giftPreferentialItem && giftPreferentialItem.length > 0 && giftPreferentialItem[itemIndex].couponids && giftPreferentialItem[itemIndex].couponnames
                        && giftPreferentialItem[itemIndex].couponnames != "") {
                        data.params["couponids"] = giftPreferentialItem[itemIndex].couponids;
                        data.params["couponnames"] = giftPreferentialItem[itemIndex].couponnames;
                        data.params["couponnums"] = giftPreferentialItem[itemIndex].couponnums;
                    }
                    cb.loader.runCommandLine('bill', data, viewmodel, (vm) => {
                        vm.on('sure1', function (data) {
                            if (giftPreferentialItem && giftPreferentialItem.length > 0) {
                                if (data && data.length > 0) {
                                    let couponids = "";
                                    let couponnames = "";
                                    let couponnums = "";
                                    let amountTotal = 0;
                                    for (let i = 0; i < data.length; i++) {
                                        //勾选了但是数量为0的不添加
                                        if (data[i].amount && data[i].amount != "0" && data[i].id && data[i].name) {
                                            if (couponids != '') {
                                                couponids += "," + data[i].id;
                                            } else {
                                                couponids += data[i].id;
                                            }

                                            if (couponnames != '') {
                                                couponnames += "," + data[i].name;
                                            } else {
                                                couponnames += data[i].name;
                                            }

                                            if (couponnums != '') {
                                                couponnums += "," + data[i].amount;
                                            } else {
                                                couponnums += data[i].amount;
                                            }
                                            amountTotal += parseInt(data[i].amount);
                                        }
                                    }
                                    editRowModel.get('giftPreferentialItem').setCellValue(itemIndex, "couponids", couponids, true);
                                    editRowModel.get('giftPreferentialItem').setCellValue(itemIndex, "couponnames", couponnames, true);
                                    editRowModel.get('giftPreferentialItem').setCellValue(itemIndex, "couponnums", couponnums, true);
                                    editRowModel.get('giftPreferentialItem').setCellValue(itemIndex, "iGiftNum", amountTotal, true);
                                }
                            }
                            vm.execute('close');
                        });
                        vm.on('promotionabandon', function () {
                            vm.execute('close');
                        });

                        vm.on('close', function () {
                            viewmodel.communication({
                                type: 'modal',
                                payload: {
                                    data: false
                                }
                            })
                        })
                        return true;
                    })
                })

                giftPreferentialItem.getEditRowModel().get('sGiftSkuNames').setState('selfDefineClick', function () {
                    let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                    let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    if (!(bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0)) {
                        return true;
                    } else {
                        orderProductskuref(editRowModel);
                        return false;
                    }
                })
                editRowModel.get("dConsumerSpending").on('afterValueChange', function (args) {
                    let count = editRowModel.get("giftPreferentialItem").getRowsCount();
                    let dConsumerSpend = editRowModel.get('dConsumerSpending').getData();
                    for (let i = 0; i < count; i++) {
                        editRowModel.get("giftPreferentialItem").setCellValue(i, 'iConsumerSpending', dConsumerSpend, true);
                    }
                })
            }

            const orderProductskuref = function (editRowModel) {
                var focusedRowIndex = editRowModel.get('giftPreferentialItem').getFocusedRowIndex();
                var giftPreferentialItem = editRowModel.get('giftPreferentialItem').getRows();
                // let focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();
                let iSendGiftWay = editRowModel.get('iSendGiftWay').getValue();
                var currentPreferentialPro = giftPreferentialItem[focusedRowIndex];
                let currentPreferentialProSku = giftPreferentialItem[focusedRowIndex].sGiftSkuCodes;
                var skuids = currentPreferentialPro.sGiftSkuIds ? currentPreferentialPro.sGiftSkuIds.split(',') : [];
                var skucodes = currentPreferentialPro.sGiftSkuCodes ? currentPreferentialPro.sGiftSkuCodes.split(',') : [];
                var skunames = currentPreferentialPro.sGiftSkuNames ? currentPreferentialPro.sGiftSkuNames.split(',') : [];
                var Skunums = currentPreferentialPro.sGiftSkunums ? currentPreferentialPro.sGiftSkunums.split(',') : [];
                var SkuAvailableNum = currentPreferentialPro.sGiftSkuAvailableNum ? currentPreferentialPro.sGiftSkuAvailableNum.split(',') : [];
                var pros = [];
                for (let i = 0; i < skuids.length; i++) {
                    let newobj = {};
                    newobj[returnSkuId] = skuids[i];
                    newobj[returnSkuCode] = skucodes[i];
                    newobj[returnSkuName] = skunames[i];
                    newobj[returnSkunums] = Skunums[i];
                    newobj[returnSkuAvailableNum] = SkuAvailableNum[i];
                    pros.push(newobj);
                }
                proMap[focusedRowIndex] = pros;
                var data = {
                    billtype: 'VoucherList',
                    billno: 'pmc_orderProductskuref',
                    params: {}
                };
                if (giftPreferentialItem && giftPreferentialItem.length > 0 && giftPreferentialItem[focusedRowIndex].couponids && giftPreferentialItem[focusedRowIndex].sGiftSkuNames
                    && giftPreferentialItem[focusedRowIndex].sGiftSkuNames != "") {
                    data.params["sGiftSkuIds"] = giftPreferentialItem[focusedRowIndex].sGiftSkuIds;
                    data.params["sGiftSkuNames"] = giftPreferentialItem[focusedRowIndex].sGiftSkuNames;
                    data.params["sGiftSkuCodes"] = giftPreferentialItem[focusedRowIndex].sGiftSkuCodes;
                    data.params["sGiftSkunums"] = giftPreferentialItem[focusedRowIndex].sGiftSkunums;
                    data.params["sGiftSkuAvailableNum"] = giftPreferentialItem[focusedRowIndex].sGiftSkuAvailableNum;
                }
                cb.loader.runCommandLine('bill', data, viewmodel, (vm) => {
                    var gridModel = vm.getGridModel();
                    gridModel.setReadOnly(false);

                    gridModel.on('beforeUnselect', indexes => {
                        cacheCodesMapFunction(gridModel, focusedRowIndex, indexes, false);
                    });
                    gridModel.on('beforeSelect', indexes => {
                        cacheCodesMapFunction(gridModel, focusedRowIndex, indexes, true);
                    });
                    gridModel.on('beforeSelectAll', args => {
                        cacheCodesMapFunction(gridModel, focusedRowIndex, null, true, true);
                    });
                    gridModel.on('beforeUnselectAll', args => {
                        cacheCodesMapFunction(gridModel, focusedRowIndex, null, false, true);
                    });
                    gridModel.on('afterCellValueChange', args => {
                        var row = gridModel.getRow(args.rowIndex);
                        var pid = row.productskus_id;
                        let index = proMap[focusedRowIndex] ? proMap[focusedRowIndex].findIndex(item => {
                            return item.productskus_id == pid;
                        }) : -1;
                        if (index != -1) proMap[focusedRowIndex][index][args.cellName] = args.value;
                    });


                    //获取参数中的价格,数量,并重置
                    gridModel.on("beforeSetDataSource", function (data) {
                        if (giftPreferentialItem && giftPreferentialItem.length > 0 && giftPreferentialItem[focusedRowIndex].sGiftSkuIds && giftPreferentialItem[focusedRowIndex].sGiftSkuNames
                            && giftPreferentialItem[focusedRowIndex].sGiftSkuNames != "") {
                            for (let i = 0; i < skuids.length; i++) {
                                for (let j = 0; j < data.length; j++) {
                                    if (data[j].productskus_id == skuids[i]) {
                                        if (Skunums[i] && Skunums[i] != "") {
                                            data[j].amount = Skunums[i];
                                        }
                                        if (SkuAvailableNum[i] && SkuAvailableNum[i] != "") {
                                            data[j].availableNum = SkuAvailableNum[i];
                                        }
                                    }
                                }
                            }
                        }
                    });
                    gridModel.on("afterSetDataSource", function (data) {
                        let selectIndexes = [];
                        data.forEach((row, index) => {
                            let i = proMap[focusedRowIndex].findIndex(item => {
                                return row.code == item.code;
                            });
                            if (i != -1) selectIndexes.push(index);
                        });
                        gridModel.select(selectIndexes);

                        gridModel.getEditRowModel().get('amount').setState('min', 0);
                        gridModel.getEditRowModel().get('availableNum').setState('min', 0);
                        if (iSendGiftWay == 1) {
                            gridModel.setColumnState("amount", "bShowIt", false);
                        } else {
                            gridModel.setColumnState("availableNum", "bShowIt", false);
                        }
                    });
                    var bLoad = false;
                    gridModel.on('beforeLoad', (args) => {
                        let banSkus = "";
                        if (args.condition) {
                            args.condition.isExtend = true;
                            args.condition.simpleVOs = [];
                        } else {
                            args.condition = {
                                "isExtend": true,
                                simpleVOs: []
                            };
                        }

                        if (currentPreferentialProSku && currentPreferentialProSku != '') {
                            args.condition.simpleVOs.push({
                                field: 'code',
                                op: 'in',
                                value1: currentPreferentialProSku.split(',')
                            });
                        }
                        //排除其他行选择的商品和sku
                        for (let i = 0; i < giftPreferentialItem.length; i++) {
                            if (i == focusedRowIndex) {
                                continue;
                            }
                            //其他行选择了sku
                            if (giftPreferentialItem[i].sGiftSkuCodes && giftPreferentialItem[i].sGiftSkuCodes != '') {
                                if (banSkus != '' && i < giftPreferentialItem.length - 1) {
                                    banSkus += ",";
                                    banSkus += giftPreferentialItem[i].sGiftSkuCodes;
                                } else {
                                    banSkus += giftPreferentialItem[i].sGiftSkuCodes;
                                }
                            }
                        }
                        let areaId;
                        if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                            if (!viewmodel.get("iAreaId").getValue()) {
                                cb.utils.alert('请选择适用区域', 'warning');
                                return false;
                            } else {
                                areaId = viewmodel.get("iAreaId").getValue();
                            }
                        }
                        if (areaId) {
                            let externalData = {"areaId": areaId};
                            args.externalData = externalData;
                        }
                        common.addProductReferCondition(viewmodel, true, args.condition, null, banSkus == "" ? null : banSkus.split(","), false);
                        if (bLoad) {
                            if (args.condition && args.condition.simpleVOs && args.condition.simpleVOs[0].field == 'code')
                                args.condition.simpleVOs.splice(0, 1);
                        }
                        bLoad = true;
                    })

                    vm.on('orderProductskuSave', function (data) {
                        let newData = proMap[focusedRowIndex];
                        if (newData) {
                            let returnSkunumsKey = returnSkunums;
                            let returnSkuAvailableNumKey = returnSkuAvailableNum;
                            let sGiftSku = {};
                            sGiftSku.numsTotal = 0;
                            sGiftSku.availableNum = 0;
                            sGiftSku.sGiftSkuIds = "";
                            sGiftSku.sGiftSkuNames = "";
                            sGiftSku.sGiftSkuCodes = "";
                            sGiftSku.sGiftSkunums = "";
                            sGiftSku.sGiftSkuAvailableNum = "";
                            for (let i = 0; i < newData.length; i++) {
                                if (iSendGiftWay == 2) {
                                    if (newData[i][returnSkunumsKey] && newData[i][returnSkunumsKey] != "") {
                                        spliceFields(newData, i, sGiftSku);
                                    } else {
                                        cb.utils.alert('赠送数量必填，不能为空', 'warning');
                                        return false;
                                    }
                                } else {
                                    if (!newData[i][returnSkuAvailableNumKey] || newData[i][returnSkuAvailableNumKey] == "") {
                                        newData[i][returnSkuAvailableNumKey] = 1000000;
                                    }
                                    spliceFields(newData, i, sGiftSku);
                                }
                            }
                            editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "sGiftSkuIds", sGiftSku.sGiftSkuIds, true);
                            editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "sGiftSkuNames", sGiftSku.sGiftSkuNames, true);
                            editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "sGiftSkuCodes", sGiftSku.sGiftSkuCodes, true);
                            if (iSendGiftWay == 2) {
                                editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "sGiftSkunums", sGiftSku.sGiftSkunums, true);
                                editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "iGiftNum", sGiftSku.numsTotal, true);
                            } else if (iSendGiftWay == 1) {
                                editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "sGiftSkuAvailableNum", sGiftSku.sGiftSkuAvailableNum, true);
                                editRowModel.get('giftPreferentialItem').setCellValue(focusedRowIndex, "dAvailableNum", sGiftSku.availableNum, true);
                            }
                        }
                        vm.execute('close');
                    });
                    vm.on('orderProductskuclose', function () {
                        vm.execute('close');
                    });

                    vm.on('close', function () {
                        viewmodel.communication({
                            type: 'modal',
                            payload: {
                                data: false
                            }
                        })
                    })
                    return true;
                })
            }

            const spliceFields = function (newData, i, sGiftSku) {
                let returnIdKey = returnSkuId;
                let returnCodeKey = returnSkuCode;
                let returnNameKey = returnSkuName;
                let returnDecKey = returnSkuSpec;
                let returnSkunumsKey = returnSkunums;
                let returnSkuAvailableNumKey = returnSkuAvailableNum;

                if (newData[i][returnIdKey] && newData[i][returnIdKey] != "") {
                    sGiftSku.sGiftSkuIds += newData[i][returnIdKey];
                    if (i != newData.length - 1)
                        sGiftSku.sGiftSkuIds += ",";
                }
                if (newData[i][returnNameKey] && newData[i][returnNameKey] != "") {
                    sGiftSku.sGiftSkuNames += newData[i][returnNameKey];
                    if (newData[i][returnDecKey] && newData[i][returnDecKey] != "") {
                        sGiftSku.sGiftSkuNames += "(" + newData[i][returnDecKey] + ")";
                    }
                    if (i != newData.length - 1)
                        sGiftSku.sGiftSkuNames += ",";
                }
                if (newData[i][returnCodeKey] && newData[i][returnCodeKey] != "") {
                    sGiftSku.sGiftSkuCodes += newData[i][returnCodeKey];
                    if (i != newData.length - 1)
                        sGiftSku.sGiftSkuCodes += ",";
                }
                if (newData[i][returnSkunumsKey] && newData[i][returnSkunumsKey] != "") {
                    sGiftSku.sGiftSkunums += newData[i][returnSkunumsKey];
                    if (i != newData.length - 1)
                        sGiftSku.sGiftSkunums += ",";
                    sGiftSku.numsTotal += parseInt(newData[i][returnSkunumsKey]);
                }
                if (newData[i][returnSkuAvailableNumKey] && newData[i][returnSkuAvailableNumKey] != "") {
                    sGiftSku.sGiftSkuAvailableNum += newData[i][returnSkuAvailableNumKey];
                    if (i != newData.length - 1)
                        sGiftSku.sGiftSkuAvailableNum += ",";
                    sGiftSku.availableNum += parseInt(newData[i][returnSkuAvailableNumKey]);
                }
            };

            const cacheCodesMapFunction = function (refGridModel, index, rowIndexes, bSelect, bAll) {
                let rows = bAll ? refGridModel.getRows() : refGridModel.getRowsByIndexes(rowIndexes);
                // let skucodes = cacheCodesMap[index] || [];
                // rows.map(row => {
                //   let i = skucodes.findIndex(code => {
                //     return code == row.code;
                //   });
                //   if (bSelect) {
                //     if (i == -1) skucodes.push(row.code);
                //   } else {
                //     if (i != -1) skucodes.splice(i, 1);
                //   }
                // });
                // cacheCodesMap[index] = skucodes;
                let pros = proMap[index] || [];
                rows.map(row => {
                    let i = pros.findIndex(pro => {
                        return pro.code == row.code;
                    });
                    if (bSelect) {
                        if (i == -1) pros.push(row);
                    } else {
                        if (i != -1) pros.splice(i, 1);
                    }
                })
                proMap[index] = pros;
            }

            const displayiSendGiftWays = function (editRowModel) {
                if (viewmodel.get("iGiftType").getValue() == 4) {
                    editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bCanModify", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iGiftNum", "bCanModify", true);
                    editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "visible", false);
                } else {
                    if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 0 && viewmodel.get('bApplyOMCChannel').getValue() == 1) {
                        if (editRowModel.get('iSendGiftWay').getValue() == 1) {
                            editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bCanModify", false);
                            editRowModel.get("giftPreferentialItem").setColumnState("iGiftNum", "bCanModify", true);
                            editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "visible", true);
                        } else {
                            editRowModel.get("giftPreferentialItem").setColumnState("dAvailableNum", "bCanModify", true);
                            editRowModel.get("giftPreferentialItem").setColumnState("iGiftNum", "bCanModify", false);
                            editRowModel.get("giftPreferentialItem").setColumnState("iSendGiftWay", "visible", false);
                        }
                    }
                }
            }

            const delSunTable = function (index) {
                let giftPreferentialStrategyList = viewmodel.get("giftPreferentialStrategy").getRows();
                if (giftPreferentialStrategyList[index] && giftPreferentialStrategyList[index].giftPreferentialItem) {
                    var rowIndexes = [];
                    let item = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels')[index].get("giftPreferentialItem");
                    let items = item.getRows();
                    if (items.length) {
                        rowIndexes.length = 0;
                        for (let i = items.length - 1; i >= 0; i--) {
                            rowIndexes.push(i);
                        }
                        item.deleteRows(rowIndexes);
                    }
                }

            }

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "iProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarkPrice",
                        "sProductPicUrl": "url",
                        "cDescribe": "modelDescription"
                    }
                    let sku_refRetId = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    }
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                    viewmodel.get("giftPreferentialMustBuyPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialMustBuyPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "iProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarketPrice",
                        "sProductPicUrl": "url",
                        "cDescribe": "modelDescription"
                    }
                    let sku_refRetId = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarketPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    }
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                    viewmodel.get("giftPreferentialMustBuyPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialMustBuyPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }

            viewmodel.get("giftPreferentialPro").on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "giftPreferentialPro", null, areaId);
                return true;
            })

            viewmodel.get("giftPreferentialMustBuyPro").on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "giftPreferentialMustBuyPro", null, areaId);
                return true;
            });

            viewmodel.get("isSpreadCode").on("afterValueChange", function (data) {
                displayisSpreadCode();
            })

            viewmodel.get('iDesignatedShop').on('afterValueChange', function (data) {
                displayiDesignatedShop();
            })

            viewmodel.get("iExtended").on('afterValueChange', function (data) {
                displayExtended();
            })

            //买A赠A修改数据结构
            if (initData && initData.iGiftType == 4) {
                // let strategyList = [];
                // let strategy = {"dConsumerSpending": null, "dConsumerSpendingItem": 1, "giftPreferentialItem": []};
                let giftPreferentialItem = [];
                for (let i = 0; i < initData.giftPreferentialStrategy.length; i++) {
                    let sy = initData.giftPreferentialStrategy[i];
                    giftPreferentialItem.push(sy.giftPreferentialItem[0]);
                }
                initData.giftPreferentialStrategy.length = 1;
                initData.giftPreferentialStrategy[0].giftPreferentialItem = giftPreferentialItem;
            }

            viewmodel.get("giftPreferentialStrategy").on('afterInsertRow', function (args) {
                let iGiftType = viewmodel.get("iGiftType").getValue();
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                displayGiftType(iGiftType, editRowModels[args.index]);
                displayStrategy(editRowModels[args.index]);
                displayiSendGiftWays(editRowModels[args.index]);
            });

            viewmodel.get("giftPreferentialStrategy").on('afterDeleteRows', function (args) {
                // let dataSource = viewmodel.get("giftPreferentialStrategy").get('dataSource');
                let iGiftType = viewmodel.get("iGiftType").getValue();
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                for (let i = 0; i < editRowModels.length; i++) {
                    displayGiftType(iGiftType, editRowModels[i])
                    displayStrategy(editRowModels[i]);
                    displayiSendGiftWays(editRowModels[i]);
                }
            });

            viewmodel.get('isAllMemberLeve').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('ifrequency').setDisabled(false);
                    viewmodel.get('giftPreferentialMemberL').setVisible(true);
                } else {
                    if (data.value.value == 1) {
                        viewmodel.get('ifrequency').setDisabled(true);
                        viewmodel.get('ifrequency').setValue(0);
                        viewmodel.get('pfrequency').setDisabled(true);
                        viewmodel.get('pfrequency').setValue('0');
                    } else {
                        viewmodel.get('ifrequency').setDisabled(false);
                    }
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                }
            });

            viewmodel.get('isShare').on("afterValueChange", function (data) {
                displayisShare();
            })

            viewmodel.on('beforeDeleteRow', function (args) {
                let giftPreferentialStrategy = viewmodel.get('giftPreferentialStrategy').getRows();
                if (giftPreferentialStrategy && giftPreferentialStrategy.length == 1 && args.params.params.cItemName == 'btnDeleteRow3') {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }
            })

            /**
             * 满额送 1     满件送2     买就送3     买A送A  4 关键词送 5
             */
            viewmodel.get('iGiftType').on('afterValueChange', function (data) {
                if (data.value.value == 5) {
                    viewmodel.get('applicableChannel').setValue("2", true);
                    viewmodel.get('isAllMemberLeve').setValue(1);
                }
                displaySpecifiedAmounts(true);
                delStrategyList();
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                if (editRowModels && editRowModels.length > 0) {
                    let iGiftType = viewmodel.get("iGiftType").getValue();
                    displayGiftType(iGiftType, editRowModels[0]);
                    displayStrategy(editRowModels[0]);
                    displayiSendGiftWays(editRowModels[0]);
                    if (iGiftType == 4) {
                        editRowModels[0].get('iSendGiftWay').setValue(1);
                        editRowModels[0].get('iSendGiftWay').setVisible(false);
                    }
                    // editRowModels[0].get('dConsumerSpending').setState("after", iGiftType == 1 || iGiftType == 3 ? "元" : "件");
                }
            });

            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                delPro();
                delClassPro();
                delExceptionPro();
                delMustBuyPro();
                delStrategyList();
            });

            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            });

            viewmodel.on("modeChange", function (data) {
                mode = data;
                if (data == "browse") {
                    common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
                } else {
                    let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                    let iGiftType = viewmodel.get("iGiftType").getValue();
                    if (iGiftType == 3 || iGiftType == 4 || iGiftType == 5) {
                        for (let i = 0; i < editRowModels.length; i++) {
                            editRowModels[i].get('btnAddRow2').setVisible(true);
                            editRowModels[i].get('btnAddRow3').setVisible(false);
                            editRowModels[i].get('btnDeleteRow3').setVisible(false);
                        }
                    } else {
                        for (let i = 0; i < editRowModels.length; i++) {
                            editRowModels[i].get('btnAddRow2').setVisible(true);
                            editRowModels[i].get('btnAddRow3').setVisible(true);
                            editRowModels[i].get('btnDeleteRow3').setVisible(true);
                        }
                    }
                    for (let i = 0; i < editRowModels.length; i++) {
                        let grandsonModel = editRowModels[i].get('giftPreferentialItem');
                        let data = grandsonModel.getData();
                        if (data.length > 0) {
                            let actionsState = [];
                            data.forEach((row, index) => {
                                actionsState.push({
                                    'btnDeleteRow2': {'visible': true}
                                })
                            })
                            grandsonModel.setActionsState(actionsState);
                        }
                    }
                    common.displayChannel(viewmodel, 'giftPreferential');
                }
            })
            viewmodel.on('afterEdit', function (data) {
                common.displayArea(viewmodel);
                common.displayEditButton(viewmodel, "iValid");
                //add by shuzhana 韩后特供
                if (viewmodel.get('isHannHoo')) {
                    displayForbidden(viewmodel);
                }
            })

            viewmodel.on('beforeEdit', function (data) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_giftpreferential');
            })

            viewmodel.on('afterMovenext', function (data) {
                common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            })

            viewmodel.on('afterMoveprev', function (data) {
                common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            })

            viewmodel.on('afterLoadData', function (args) {
                common.displayArea(viewmodel);
                common.hideNoStore(viewmodel);
                common.displayActivityMode(viewmodel);
                common.displayEditButton(viewmodel, "iValid");
                viewmodel.get('promotion_code').setDisabled(true);
                if (!(viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 0 && viewmodel.get('bApplyOMCChannel').getValue() == 1)) {
                    viewmodel.get('btnPromotionCheck').setVisible(false);
                }
                //add by shuzhana 韩后特供
                if (viewmodel.get('isHannHoo')) {
                    displayForbidden(viewmodel);
                }
                viewmodel.get('pfrequency').setState('min', 0);
                viewmodel.get('prompt').setValue('此设置仅适用于订单中心促销');
                viewmodel.get('prompt').setDisabled(true);
                let iGiftType = viewmodel.get("iGiftType").getValue();
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                if (mode === 'add') {
                    // viewmodel.get("giftPreferentialStrategy").setState('defaultSelectedRowIndexes', true);
                    if (action !== 'copy') {
                        viewmodel.get('giftPreferentialStrategy').appendRow({});
                    }
                    //shuzhana 新增态不显示促销编码
                    viewmodel.get('promotion_code').setVisible(false);
                    editRowModels[0].get('dConsumerSpendingItem').setVisible(false);
                }
                if (mode === 'edit' || mode === 'browse' || action === 'copy') {
                    if (!viewmodel.get('bApplyOMCChannel').getValue()) {
                        viewmodel.get('promotion_code').setVisible(false);
                    }

                    // let iGiftType = initData.iGiftType;
                    // let bApplyOMCChannel = initData.bApplyOMCChannel;
                    for (let i = 0; i < editRowModels.length; i++) {
                        displayGiftType(iGiftType, editRowModels[i]);
                        displayStrategy(editRowModels[i]);
                        displayiSendGiftWays(editRowModels[i]);
                        if (mode === 'browse') {
                            let grandsonModel = editRowModels[i].get('giftPreferentialItem');
                            let data = grandsonModel.getData();
                            if (data.length > 0) {
                                let actionsState = [];
                                data.forEach((row, index) => {
                                    actionsState.push({
                                        'btnDeleteRow2': {'visible': false}
                                    })
                                })
                                grandsonModel.setActionsState(actionsState);
                            }
                        }
                    }
                }
                displayMustBuyPro(viewmodel);
                displayisShare();
                displayPrice(viewmodel);
                displayisAllProduct(viewmodel);
                displayiDesignatedShop();
                displayisSpreadCode();
                displaySpecifiedAmounts(false);
                common.displayChannel(viewmodel, 'giftPreferential');
                //
                viewmodel.get("giftPreferentialClassPro").setState('bLinkage', true);

                if (this.get('isAllMemberLeve').getValue() == 0) {
                    viewmodel.get('ifrequency').setDisabled(false);
                    viewmodel.get('giftPreferentialMemberL').setVisible(true);
                } else {
                    if (this.get('isAllMemberLeve').getValue() == 1) {
                        viewmodel.get('ifrequency').setDisabled(true);
                    } else {
                        viewmodel.get('ifrequency').setDisabled(false);
                    }
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                }
                if (viewmodel.get('promotionParams') && viewmodel.get('promotionParams').registInfo) {
                    let registInfo = viewmodel.get('promotionParams').registInfo;
                    if (registInfo.DST != undefined && registInfo.DST != null && registInfo.DST) {
                        if (mode === 'add' && action !== 'copy') {
                            viewmodel.get('applyOnlineChannel').setValue(false);
                            viewmodel.get('applyOffLineChannel').setValue(false);
                        }
                        let auditStatusModel = viewmodel.get('applicableChannel');
                        let dataSource = auditStatusModel.getState('dataSource');
                        let userType = cb.rest.AppContext.user.cType;
                        let newSource = [];
                        let flag = false
                        dataSource && dataSource.forEach(data => {
                            if (data.value == 2) {
                                flag = true
                            }
                            newSource.push({
                                value: data.value,
                                nameType: 'text',
                                text: data.text
                            });
                        });
                        //
                        if (!flag && userType != 3 && userType != 4) {//非商家操作员
                            newSource.push({
                                value: "2",
                                nameType: 'text',
                                text: '订单中心'
                            });
                        }
                        auditStatusModel.setDataSource(newSource);
                        let auditStatusModels = viewmodel.get('iGiftType');
                        let dataSources = auditStatusModels.getState('dataSource');
                        let newSources = [];
                        let flags = false
                        dataSources && dataSources.forEach(datas => {
                            if (datas.value == 5) {
                                flags = true
                            }
                            newSources.push({
                                value: datas.value,
                                nameType: 'text',
                                text: datas.text
                            });
                        });
                        if (!flags && userType != 3 && userType != 4) {
                            newSources.push({
                                value: "5",
                                nameType: 'text',
                                text: '按关键词'
                            });
                        }
                        auditStatusModels.setDataSource(newSources);
                    }
                }

                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('applicableChannel').setValue(["0"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }
                if (this.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('giftPreferentialStore').setVisible(false);
                    viewmodel.get('offLineStore').setValue(1);
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('isShare').setVisible(false);
                    viewmodel.get('isTakeInShare').setVisible(false);
                    viewmodel.get('iLineDiscount').setVisible(false);
                } else {
                    viewmodel.get("bMustBuyProduct").setVisible(false);
                    viewmodel.get("isSpreadCode").setVisible(true);
                    viewmodel.get('offLineStore').setVisible(true);
                    viewmodel.get('isShare').setVisible(true);
                    viewmodel.get('isTakeInShare').setVisible(true);
                    if (viewmodel.get('offLineStore').getValue() == 1) {
                        viewmodel.get('giftPreferentialStore').setVisible(false);
                    } else {
                        viewmodel.get('giftPreferentialStore').setVisible(true);
                    }
                    //仅勾线下
                    if (this.get('applyOnlineChannel').getValue() == 0) {
                        viewmodel.get('iSendPoint').setVisible(true);
                        viewmodel.get('iLineDiscount').setVisible(true);
                    } else {
                        viewmodel.get('iSendPoint').setVisible(false);
                        viewmodel.get('iLineDiscount').setVisible(false);
                    }
                }
                if (this.get('applyOnlineChannel').getValue() == 0) {
                    viewmodel.get("bMustBuyProduct").setVisible(false);
                    viewmodel.get('terminalType').setVisible(false);
                } else {
                    viewmodel.get("isSpreadCode").setVisible(true);
                    viewmodel.get('terminalType').setVisible(true);
                }
                if (this.get('ifrequency').getValue() == 0) {
                    viewmodel.get('pfrequency').setDisabled(true);
                } else {
                    viewmodel.get('pfrequency').setDisabled(false);
                }
                if (viewmodel.get('isShare').getValue() == 0) {
                    viewmodel.get('isTakeInShare').setDisabled(true);
                } else {
                    viewmodel.get('isTakeInShare').setDisabled(false);
                }

                if (viewmodel.get('bApplyOMCChannel').getValue() == 1) {
                    viewmodel.get("bMustBuyProduct").setVisible(false);
                    /*viewmodel.get('ifrequency').setVisible(false);
                    viewmodel.get('pfrequency').setVisible(false);*/
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('iLineDiscount').setVisible(false);

                  if (viewmodel.get('applicableChannel').getValue()) {
                        //深拷贝一下，setValue方法会===比较，所以需要用一个新的对象
                        let newValue = viewmodel.get('applicableChannel').getValue();
                        newValue.push("2");
                        viewmodel.get('applicableChannel').setValue(newValue);
                        newValue = viewmodel.get('applicableChannel').getValue().slice();
                        viewmodel.get('applicableChannel').setValue(newValue);
                    } else {
                        viewmodel.get('applicableChannel').setValue(["2"]);
                    }
                    //仅勾订单中心
                    let iGiftType = viewmodel.get("iGiftType").getValue();
                    if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                        viewmodel.get("isSpreadCode").setVisible(false);
                        if (viewmodel.get('isAllProduct').getValue() == 0 && iGiftType != 4) {
                            viewmodel.get("iExtended").setVisible(true);
                            displayExtended();
                        } else {
                            viewmodel.get("iExtended").setVisible(false);
                        }
                    } else {
                        viewmodel.get("iExtended").setVisible(false);
                    }
                    viewmodel.get('iDesignatedShop').setVisible(true);
                    viewmodel.get('iMatchingTime').setVisible(true);
                    viewmodel.get('prompt').setVisible(true);
                } else {
                    viewmodel.get("iExtended").setVisible(false);
                    viewmodel.get("iExtended").setValue(false)
                    viewmodel.get('iDesignatedShop').setVisible(false);
                    viewmodel.get('preferentialShop').setVisible(false);
                    viewmodel.get('iMatchingTime').setVisible(false);
                    viewmodel.get('prompt').setVisible(false);
                    displayExtended();
                }
              displayActivityMode(viewmodel.get('applicableChannel').getValue());
            });
            viewmodel.get("giftPreferentialStrategy").on('afterSetDataSource', function (args) {
                let params = viewmodel.getParams();
                if (params.mode == "browse")
                    common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            });
            // viewmodel.get("giftPreferentialStrategy").on('afterSetDataSource', function (args) {
            //     debugger
            //     let iGiftType = initData.iGiftType;
            //     let bApplyOMCChannel = initData.bApplyOMCChannel;
            //     var editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
            //     for (let i = 0; i < args.length; i++) {
            //         displayGiftType(iGiftType, editRowModels[i]);
            //         displayStrategy(editRowModels[i]);
            //     }
            // });

            viewmodel.get('ifrequency').on('afterValueChange', function (data) {
                if (!data.value) {
                    viewmodel.get('pfrequency').setDisabled(true);
                    viewmodel.get('pfrequency').setValue('0');
                } else {
                    viewmodel.get('pfrequency').setDisabled(false);
                    viewmodel.get('pfrequency').setValue('1');
                }
            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('giftPreferentialStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('bApplyOMCChannel').setValue(false);
                viewmodel.get("isSpreadCode").setVisible(false);
                viewmodel.get('iSendPoint').setVisible(false);
                viewmodel.get('isShare').setVisible(false);
                viewmodel.get('isTakeInShare').setVisible(false);
                viewmodel.get('iLineDiscount').setVisible(false);
                viewmodel.get('iDesignatedShop').setVisible(false);
                viewmodel.get('preferentialShop').setVisible(false);
                viewmodel.get('iMatchingTime').setVisible(false);
                viewmodel.get('prompt').setVisible(false);
                viewmodel.get('ifrequency').setVisible(true);
                viewmodel.get('pfrequency').setVisible(true);
                viewmodel.get("bMustBuyProduct").setValue(0);
                viewmodel.get("bMustBuyProduct").setVisible(false);
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get("isSpreadCode").setVisible(true);
                    } else if (data.value[i].value == 1) {
                        viewmodel.get("bMustBuyProduct").setVisible(false);
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        viewmodel.get("isSpreadCode").setVisible(true);
                        viewmodel.get('isShare').setVisible(true);
                        viewmodel.get('isTakeInShare').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('giftPreferentialStore').setVisible(false);
                        } else {
                            viewmodel.get('giftPreferentialStore').setVisible(true);
                        }
                    } else if (data.value[i].value == 2) {
                        viewmodel.get("bMustBuyProduct").setVisible(false);
                        /*viewmodel.get('ifrequency').setVisible(false);
                        viewmodel.get('pfrequency').setVisible(false);
                        viewmodel.get('ifrequency').setValue(false);
                        viewmodel.get('pfrequency').setDisabled(true);
                        viewmodel.get('pfrequency').setValue('0');*/
                        viewmodel.get('iDesignatedShop').setVisible(true);
                        viewmodel.get('bApplyOMCChannel').setValue(true);
                        viewmodel.get('iMatchingTime').setVisible(true);
                        viewmodel.get('prompt').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0) {
                                viewmodel.get('iDesignatedShop').setValue(2);
                            }
                        }
                        displayiDesignatedShop();
                    }
                }
                displayisAllProduct(viewmodel);
                if (viewmodel.get('bApplyOMCChannel').getValue()) {
                    viewmodel.get('isAllMemberLeve').setValue(1);
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                    let auditStatusModel = viewmodel.get('isAllMemberLeve');
                    let dataSource = auditStatusModel.getState('dataSource');
                    let newSource = [];
                    dataSource && dataSource.forEach(data => {
                        //置灰全部会员2和指定会员0
                        newSource.push({
                            value: data.value,
                            nameType: 'text',
                            text: data.text,
                            //disabled: data.value == 0 || data.value == 2
                            disabled: data.value == 0 //20210408 lz 订单中心买赠支持限购次数，勾选了适用于“订单中心”时，买家适用范围允许选择“全部买家”“全部会员”
                        });
                    });
                    auditStatusModel.setDataSource(newSource);
                    let giftPreferentialStrategyList = viewmodel.get("giftPreferentialStrategy").getRows();
                    //切换活动类型时 只保留第一个策略，删除所有孙表行数据
                    if (giftPreferentialStrategyList && giftPreferentialStrategyList.length > 0) {
                        for (let i = 0; i < giftPreferentialStrategyList.length; i++) {
                            delSunTable(i);
                        }
                    }

                } else {
                    let auditStatusModel = viewmodel.get('isAllMemberLeve');
                    auditStatusModel.setDataSource(isAllMemberLeveArray);
                }
                if (viewmodel.get('isAllMemberLeve').getValue() == 0) {
                    viewmodel.get('ifrequency').setDisabled(false);
                    viewmodel.get('giftPreferentialMemberL').setVisible(true);
                } else {
                    if (viewmodel.get('isAllMemberLeve').getValue() == 1) {
                        viewmodel.get('ifrequency').setDisabled(true);
                        viewmodel.get('ifrequency').setValue(0);
                        viewmodel.get('pfrequency').setDisabled(true);
                        viewmodel.get('pfrequency').setValue('0');
                    } else {
                        viewmodel.get('ifrequency').setDisabled(false);
                    }
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                }
                let iGiftType = viewmodel.get('iGiftType').getValue();
                let onlyApplyOMC = (data.value.length == 1 && data.value[0].value == 2);//仅勾订单中心
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                viewmodel.get('btnPromotionCheck').setVisible(onlyApplyOMC);
                for (let i = 0; i < editRowModels.length; i++) {
                    displayGiftType(iGiftType, editRowModels[i]);
                    displayStrategy(editRowModels[i]);
                    displayiSendGiftWays(editRowModels[i]);
                    let giftPreferentialItem = editRowModels[i].get("giftPreferentialItem");
                    giftPreferentialItem.setColumnState("dAvailableNum", "bShowIt", onlyApplyOMC);
                    giftPreferentialItem.setColumnState("dRemainingAvailableNum", "bShowIt", onlyApplyOMC);
                    if (!onlyApplyOMC) {
                        editRowModels[i].get('iSendGiftWay').setValue(1);
                    }
                    if (viewmodel.get('bApplyOMCChannel').getValue()) {
                        // //勾选订单中心删除 赠品类型不是指定数量赠品的行和选择了商品的行
                        let itemList = giftPreferentialItem.getRows();
                        let rowIndex = [];
                        for (let j = 0; j < itemList.length; j++) {
                            if (itemList[j].iGiftItemType != 1 || (itemList[j].sgiftids && itemList[j].sgiftids != '')) {
                                rowIndex.push(j);
                            }
                        }
                        giftPreferentialItem.deleteRows(rowIndex);
                        if (iGiftType != 4) {
                            if (onlyApplyOMC) {
                                if (editRowModels[i].get('iSendGiftWay').getValue() == 1) {
                                    giftPreferentialItem.setColumnState("iSendGiftWay", "bShowIt", true);
                                } else {
                                    giftPreferentialItem.setColumnState("iSendGiftWay", "bShowIt", false);
                                }
                            } else {
                                giftPreferentialItem.setColumnState("iSendGiftWay", "bShowIt", true);
                            }
                        } else {
                            giftPreferentialItem.setColumnState("iSendGiftWay", "bShowIt", false);
                        }
                        let auditStatusModel = giftPreferentialItem.getEditRowModel().get('iGiftItemType');
                        let newSource = [];
                        iGiftItemTypeArray && iGiftItemTypeArray.forEach(data => {
                            if (data.value == 1) {
                                newSource.push({
                                    value: data.value,
                                    nameType: 'text',
                                    text: data.text
                                });
                            }
                        });
                        auditStatusModel.setDataSource(newSource);
                    } else {
                        giftPreferentialItem.setColumnState("iSendGiftWay", "bShowIt", false);
                        if (iGiftType == 3 || iGiftType == 5) {
                            let auditStatusModel = editRowModels[i].get('giftPreferentialItem').getEditRowModel().get('iGiftItemType');
                            let newSource = [];
                            iGiftItemTypeArray && iGiftItemTypeArray.forEach(data => {
                                if (data.value != 3) {
                                    newSource.push({
                                        value: data.value,
                                        nameType: 'text',
                                        text: data.text
                                    });
                                }
                            });
                            auditStatusModel.setDataSource(newSource);
                        } else {
                            let auditStatusModel = editRowModels[i].get('giftPreferentialItem').getEditRowModel().get('iGiftItemType');
                            auditStatusModel.setDataSource(iGiftItemTypeArray);
                        }
                    }
                }
                //仅勾线下
                if (data.value.length == 1 && data.value[0].value == 1) {
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('iLineDiscount').setVisible(true);
                } else if (data.value.length == 1 && data.value[0].value == 0) {//仅勾线上
                    viewmodel.get("bMustBuyProduct").setVisible(true);
                }
                displayMustBuyPro(viewmodel);
                displayPrice(viewmodel);
                displaySpecifiedAmounts(true);
                displayActivityMode(viewmodel.get('applicableChannel').getValue());
            });

            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value == 1) {
                    viewmodel.get('giftPreferentialStore').setVisible(false);
                } else {
                    viewmodel.get('giftPreferentialStore').setVisible(true);
                }
            });

            viewmodel.get('isAllProduct').on('afterValueChange', function (data) {
                delPro();
                delClassPro();
                displayisAllProduct(viewmodel);
            })

            viewmodel.get("iActivityItemType").on('afterValueChange', function (args) {
                delPro();
                delClassPro();
                delExceptionPro();
                displayiActivityItemType(viewmodel);
                displayReferType(viewmodel, args.value.value);
            })

            viewmodel.get("bExceptionalProduct").on('afterValueChange', function (args) {
                delExceptionPro();
                displaybException(viewmodel);
            });

            viewmodel.get("specifiedAmounts").on('afterValueChange', function (data) {
                if (data.value.value === true || data.value.value === 'true' || data.value.value === 1 || data.value.value === '1' ) {
                    viewmodel.get('bCrossRegionSelect').setDisabled(true);
                    viewmodel.get('bCrossRegionSelect').setValue(0);
                } else {
                    viewmodel.get('bCrossRegionSelect').setDisabled(false);
                }
            });

            viewmodel.get('giftPreferentialStrategy').on('afterCellValueChange', function (args) {
                if (args.cellName == 'iSendGiftWay') {
                    let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                    displayiSendGiftWays(editRowModels[args.rowIndex]);
                    delSunTable([args.rowIndex]);
                }
            })

            viewmodel.get('giftPreferentialExceptionPro').on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "giftPreferentialExceptionPro", null, areaId);
                if (viewmodel.get('giftPreferentialClassPro').getShowValue() && viewmodel.get('giftPreferentialClassPro').getShowValue().length > 0) {
                    let ids = [];
                    for (let i = 0; i < viewmodel.get('giftPreferentialClassPro').getShowValue().length; i++) {
                        ids.push(viewmodel.get('giftPreferentialClassPro').getShowValue()[i].iReferenceId);
                    }
                    if (ids.length > 0) {
                        let field = '';
                        if (data && data.cellName == "sProductSkuCode") {
                            field = 'productId.';
                        }
                        //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                        let simpleConditions = [];
                        if (viewmodel.get('iActivityItemType').getValue() == 1) {
                            field += 'productClass';
                        } else if (viewmodel.get('iActivityItemType').getValue() == 2) {
                            field += 'productTemplate';
                        } else if (viewmodel.get('iActivityItemType').getValue() == 3) {
                            field += 'brand';
                        } else if (viewmodel.get('iActivityItemType').getValue() == 4) {
                            field += 'productTags.tagId';
                        }
                        if (data.context.getFilter() && data.context.getFilter().simpleVOs) {
                            data.context.getFilter().simpleVOs.push({
                                field: field,
                                op: 'in',
                                value1: ids
                            });
                        } else {
                            let condition = {
                                "isExtend": true,
                                simpleVOs: []
                            };
                            condition.simpleVOs.push({
                                field: field,
                                op: 'in',
                                value1: ids
                            });
                            data.context.setFilter(condition);
                        }
                    }
                } else {
                    let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                    let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    //仅勾订单中心不校验
                    if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0 && viewmodel.get('isAllProduct').getValue() == 1) {
                    } else {
                        cb.utils.alert('请选择适用商品类型', 'warning');
                        return false;
                    }
                }
                return true;
            })

            viewmodel.get("giftPreferentialMustBuyPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                } else {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                }
            })

            viewmodel.get("giftPreferentialPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                }
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                }
            })
            viewmodel.get("giftPreferentialExceptionPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                }
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                }
            })

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('giftPreferentialPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("giftPreferentialPro").deleteRows(rowIndexes);
            })
            //清除全部商品
            viewmodel.on('batchProDeletes', function (args) {
                debugger
                let counts = viewmodel.get('giftPreferentialExceptionPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("giftPreferentialExceptionPro").deleteRows(rowIndexes);
            })
            //必买商品清除全部商品
            viewmodel.on('batchBuyProDeletePro', function (args) {
                let counts = viewmodel.get('giftPreferentialMustBuyPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("giftPreferentialMustBuyPro").deleteRows(rowIndexes);
            })

            viewmodel.on('statictempexport', function (params) {
                const openUrl = params && params.cSvcUrl;
                if (!openUrl) {
                    cb.utils.alert('导出模板的地址为空', 'error');
                    return;
                }
                window.open(openUrl);
            });

            viewmodel.on('batchimport', function (params) {
                const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_seckill`;
                const eleInput = document.createElement('input');
                eleInput.type = 'file';
                eleInput.style.display = 'none';
                eleInput.onchange = function (e) {
                    const formData = new FormData();
                    formData['enctype'] = 'multipart/form-data';
                    formData.append('file', e.target.files[0]);

                    var param = {};
                    param.type = 3;
                    param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    param.applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    formData.append('data', JSON.stringify(param));

                    cb.utils.alert(`导入中，请稍后`, 'info');

                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', url, true);
                    xhr.send(formData);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState !== 4) return;
                        if (xhr.status === 200) {
                            var ajaxResult = JSON.parse(xhr.responseText);
                            if (ajaxResult.code === 200) {
                                if (ajaxResult.data.code === 200) {
                                    var array = [];
                                    var res = ajaxResult.data.data;
                                    var gridModel = viewmodel.get("giftPreferentialPro");
                                    for (let i = 0; i < res.data.length; i++) {
                                        var appendData = {};
                                        var data = res.data[i];
                                        appendData.iProductIdType = data.iProductIdType;
                                        if (appendData.iProductIdType == 0) {
                                            appendData.sProductCode = data.cCode;
                                            appendData.sProductName = data.sProductName;
                                        } else {
                                            appendData.sProductCode = data.productCode;
                                            appendData.sProductName = data.productName;
                                            appendData.sProductSkuCode = data.cCode;
                                            appendData.sProductSkuName = data.sProductName;
                                        }
                                        appendData.fMarkPrice = data.fMarkPrice;
                                        appendData.fSalePrice = data.fSalePrice;
                                        appendData.iProductId = data.iProductId;
                                        appendData.sProductPicUrl = data.sProductPicUrl;
                                        array.push(appendData);
                                        // gridModel.appendRow(appendData);
                                    }
                                    let count = gridModel.getRowsCount();
                                    var indexes = [];
                                    for (let i = count - 1; i >= 0; i--) {
                                        indexes.push(i);
                                    }
                                    gridModel.deleteRows(indexes);
                                    gridModel.insertRows(0, array);
                                    var errorMessages = '';
                                    if (res.errorCount) {
                                        for (let i = 0; i < res.allMsgs.length; i++) {
                                            if (res.allMsgs[i].isError) {
                                                errorMessages += res.allMsgs[i].msg;
                                            }
                                        }
                                    }
                                    cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${res.errorMsgs + errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                                } else {
                                    cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                                }
                            } else {
                                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
                            }
                        }
                    };
                    document.body.removeChild(eleInput);
                };
                document.body.appendChild(eleInput);
                eleInput.click();
            });

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);

                obj.iMutexType = 0;
                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                // obj.isTakeInShare = setCheckBoxEnum(obj.isTakeInShare);


                obj.cMonthDays = String(obj.cMonthDays);

              if (this.get('cMonthDays').getValue() && this.get('cMonthDays').getValue() != '') {
                obj.cMonthDays = ',' + obj.cMonthDays + ',';
              }

              if (this.get('cWeekDays').getValue() && this.get('cWeekDays').getValue() != '') {
                obj.cWeekDays = ',' + obj.cWeekDays + ',';
              }


                if (viewmodel.get('ifrequency').getValue() == 1 && (!viewmodel.get('pfrequency').getValue() || viewmodel.get('pfrequency').getValue() == 0)) {
                    cb.utils.alert('请正确填写每人参加次数', 'warning');
                    return false;
                }

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('isAllMemberLeve').getValue() == '0' && this.get('giftPreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('isAllMemberLeve').getValue() != '0') {
                    obj.giftPreferentialMemberL = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('giftPreferentialStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (this.get('bApplyOMCChannel').getValue() == '0') {
                        if (obj.isAllMemberLeve == 1) {
                            obj.isAllMemberLeve = 2;
                        }
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.giftPreferentialStore = [];
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('dStartDate').getValue() <= nowDates.format('yyyy-MM-dd hh:mm:ss')) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (viewmodel.get('dStartDate').getValue() >= viewmodel.get('dEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (viewmodel.get('bApplyOMCChannel').getValue() == 1 && viewmodel.get('iDesignatedShop').getValue() == 2) {
                    if (!viewmodel.get('preferentialShop') || viewmodel.get('preferentialShop').getShowValue() == "") {
                        cb.utils.alert('请选择指定店铺', 'warning');
                        return false;
                    }
                }


              var activityModeValidNotCheck = this.get('applyOnlineChannel').getValue() == '1' && this.get('applyOffLineChannel').getValue() == '0'

              if (!activityModeValidNotCheck){
                //每天、每周、每月活动时间控制
                if (this.get('activityMode').getValue() == 1) {
                  if (!this.get('beginTime').getValue() || !this.get('endTime').getValue()) {
                    cb.utils.alert('每天活动时间不能为空', 'warning');
                    return false;
                  }
                  if (this.get('beginTime').getValue() >= this.get('endTime').getValue()) {
                    cb.utils.alert('每天活动开始时间必须小于结束时间', 'warning');
                    return false;
                  }
                } else if (this.get('activityMode').getValue() == 2) {
                  if (!this.get('cWeekBeginTime').getValue() || !this.get('cWeekEndTime').getValue() || !this.get('cWeekDays').getValue()) {
                    cb.utils.alert('每周活动时间不能为空', 'warning');
                    return false;
                  }
                  if (this.get('cWeekBeginTime').getValue() >= this.get('cWeekEndTime').getValue()) {
                    cb.utils.alert('每周活动开始时间必须小于结束时间', 'warning');
                    return false;
                  }
                } else if (this.get('activityMode').getValue() == 3) {
                  if (!this.get('cMonthDays').getValue() || !this.get('cMonthBeginTime').getValue() || !this.get('cMonthEndTime').getValue()) {
                    cb.utils.alert('每月活动时间不能为空', 'warning');
                    return false;
                  }
                  if (this.get('cMonthBeginTime').getValue() >= this.get('cMonthEndTime').getValue()) {
                    cb.utils.alert('每月活动开始时间必须小于结束时间', 'warning');
                    return false;
                  }
                }
              }


                if (this.get('isAllProduct').getValue() == 0) {
                    if (viewmodel.get("iActivityItemType").getValue() == 0) {
                        if (!viewmodel.get('giftPreferentialPro').getRows() || viewmodel.get('giftPreferentialPro').getRows().length < 1) {
                            cb.utils.alert('请选择适用商品', 'warning');
                            return false;
                        } else {
                            for (let i = 0; i < viewmodel.get('giftPreferentialPro').getRows().length; i++) {
                                if (!viewmodel.get('giftPreferentialPro').getRows()[i].iProductId) {
                                    cb.utils.alert('请选择第' + (i + 1) + '行适用商品', 'warning');
                                    return false;
                                }
                            }
                            if (!cb.utils.isEmpty(obj.giftPreferentialPro)) {
                                for (let j = 0; j < obj.giftPreferentialPro.length; j++) {
                                    if (cb.utils.isEmpty(obj.giftPreferentialPro[j].fMarkPrice)) {
                                        obj.giftPreferentialPro[j].fMarkPrice = 0;
                                    }
                                    if (cb.utils.isEmpty(obj.giftPreferentialPro[j].fSalePrice)) {
                                        obj.giftPreferentialPro[j].fSalePrice = 0;
                                    }
                                }
                            }
                        }
                    } else {
                        if (!viewmodel.get('giftPreferentialClassPro').getShowValue() || viewmodel.get('giftPreferentialClassPro').getShowValue().length < 1) {
                            cb.utils.alert('请选择适用商品类型', 'warning');
                            return false;
                        } else {
                            if (obj.giftPreferentialClassPro) {
                                for (let i = 0; i < obj.giftPreferentialClassPro.length; i++) {
                                    let classPro = obj.giftPreferentialClassPro[i];
                                    classPro.iReferType = viewmodel.get("iActivityItemType").getValue() - 1;
                                }
                            }
                        }
                    }
                }

                if (viewmodel.get('bMustBuyProduct').getValue() == 1) {
                    if (!viewmodel.get('giftPreferentialMustBuyPro').getRows() || viewmodel.get('giftPreferentialMustBuyPro').getRows().length < 1) {
                        cb.utils.alert('请选择必选商品', 'warning');
                        return false;
                    } else {
                        for (let i = 0; i < viewmodel.get('giftPreferentialMustBuyPro').getRows().length; i++) {
                            if (!viewmodel.get('giftPreferentialMustBuyPro').getRows()[i].iProductId) {
                                cb.utils.alert('请选择第' + (i + 1) + '行必选商品', 'warning');
                                return false;
                            }
                            if (!cb.utils.isEmpty(obj.giftPreferentialMustBuyPro)) {
                                for (let j = 0; j < obj.giftPreferentialMustBuyPro.length; j++) {
                                    if (cb.utils.isEmpty(obj.giftPreferentialMustBuyPro[j].fMarkPrice)) {
                                        obj.giftPreferentialMustBuyPro[j].fMarkPrice = 0;
                                    }
                                    if (cb.utils.isEmpty(obj.giftPreferentialMustBuyPro[j].fSalePrice)) {
                                        obj.giftPreferentialMustBuyPro[j].fSalePrice = 0;
                                    }
                                }
                            }
                        }
                    }
                }

                if (viewmodel.get('bExceptionalProduct').getValue() == 1) {
                    if (!viewmodel.get('giftPreferentialExceptionPro').getRows() || viewmodel.get('giftPreferentialExceptionPro').getRows().length < 1) {
                        cb.utils.alert('请选择例外商品', 'warning');
                        return false;
                    } else {
                        for (let i = 0; i < viewmodel.get('giftPreferentialExceptionPro').getRows().length; i++) {
                            if (!viewmodel.get('giftPreferentialExceptionPro').getRows()[i].iProductId) {
                                cb.utils.alert('请选择第' + (i + 1) + '行例外商品', 'warning');
                                return false;
                            }
                        }
                        if (!cb.utils.isEmpty(obj.giftPreferentialExceptionPro)) {
                            for (let j = 0; j < obj.giftPreferentialExceptionPro.length; j++) {
                                if (cb.utils.isEmpty(obj.giftPreferentialExceptionPro[j].fMarkPrice)) {
                                    obj.giftPreferentialExceptionPro[j].fMarkPrice = 0;
                                }
                                if (cb.utils.isEmpty(obj.giftPreferentialExceptionPro[j].fSalePrice)) {
                                    obj.giftPreferentialExceptionPro[j].fSalePrice = 0;
                                }
                            }
                        }
                    }
                }

                if (this.get('iGiftType')) {
                    let iGiftType = this.get('iGiftType').getValue();
                    if (iGiftType == 4) {
                        viewmodel.setCache('entryMode', 'edit');
                    }
                    if (iGiftType == 5) {
                        if (viewmodel.get('remarkType').getValue().length == 0) {
                            cb.utils.alert('请选择关键词类型', 'warning');
                            return false;
                        }
                        if (viewmodel.get('remarkKeywords').getValue() == undefined || viewmodel.get('remarkKeywords').getValue() == "") {
                            cb.utils.alert('请输入关键词', 'warning');
                            return false;
                        }
                    }
                    if (viewmodel.get('giftPreferentialStrategy').getRows()) {
                        let dConsumerSpending;//比较分组的满足条件  后组的满额/满件条件必须大于前组满额/满件条件
                        for (let i = 0; i < viewmodel.get('giftPreferentialStrategy').getRows().length; i++) {
                            let strategy = viewmodel.get('giftPreferentialStrategy').getRows()[i];
                            //买就送不用输入满额条件 买A赠A下面判断
                            if (iGiftType != 3 && iGiftType != 4  && iGiftType != 5) {
                                if (!strategy.dConsumerSpending || strategy.dConsumerSpending <= 0) {
                                    cb.utils.alert('请输入第' + (i + 1) + '组的满' + (iGiftType == 1 ? '额' : '件') + '条件', 'warning');
                                    return false;
                                }
                                if (i == 0) {
                                    dConsumerSpending = strategy.dConsumerSpending;
                                } else {
                                    if (dConsumerSpending >= strategy.dConsumerSpending) {
                                        cb.utils.alert('第' + (i + 1) + '组的满' + (this.get('iGiftType').getValue() == 1 ? '额' : '件') + '条件必须大于第' + i + '组的满'
                                            + (this.get('iGiftType').getValue() == 1 ? '额' : '件') + '条件', 'warning');
                                        return false;
                                    } else {
                                        dConsumerSpending = strategy.dConsumerSpending;
                                    }
                                }
                            } else if (iGiftType == 3 || iGiftType == 5) {//买就送
                                let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                                let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                                //仅勾订单中心校验买就送的满件数量
                                if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0) {
                                    if (!strategy.dConsumerSpendingItem || strategy.dConsumerSpendingItem <= 0) {
                                        cb.utils.alert('请输入第' + (i + 1) + '组的满件条件', 'warning');
                                        return false;
                                    }
                                    //买就送额度可以为0
                                    if (!strategy.dConsumerSpending || strategy.dConsumerSpending < 0) {
                                        cb.utils.alert('请输入第' + (i + 1) + '组的满额条件', 'warning');
                                        return false;
                                    }
                                }
                            }
                            if (!strategy.giftPreferentialItem || strategy.giftPreferentialItem.length == 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息', 'warning');
                                return false;
                            } else {
                                let itemCount = 0;
                                let dItemConsumerSpending;//比较买A赠A分组的满足条件  后组的满额/满件条件必须大于前组满额/满件条件
                                for (let j = 0; j < strategy.giftPreferentialItem.length; j++) {
                                    let item = strategy.giftPreferentialItem[j];
                                    if (item._status != 'Delete') {
                                        itemCount++;
                                        //买A赠A校验满额/件条件
                                        if (iGiftType == 4) {
                                            if (!item.iConsumerSpending || item.iConsumerSpending <= 0) {
                                                cb.utils.alert('请输入第' + (i + 1) + '组的满' + (iGiftType == 1 ? '额' : '件') + '条件', 'warning');
                                                return false;
                                            }
                                            if (i == 0) {
                                                dItemConsumerSpending = item.iConsumerSpending;
                                            } else {
                                                if (dItemConsumerSpending >= item.iConsumerSpending) {
                                                    cb.utils.alert('第' + itemCount + '行的满' + (this.get('iGiftType').getValue() == 1
                                                        ? '额' : '件') + '条件必须大于第' + itemCount + '行的满' + (this.get('iGiftType').getValue() == 1
                                                        ? '额' : '件') + '条件', 'warning');
                                                    return false;
                                                } else {
                                                    dItemConsumerSpending = item.iConsumerSpending;
                                                }
                                            }
                                        }
                                        //倍增检查倍增上限
                                        // if (item.icapping != undefined && item.icapping != null && item.icapping == 1) {
                                        //     if (!item.dToplimit || item.dToplimit == 0) {
                                        //         cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息第' + (j + 1) + "行的倍增上限", 'warning');
                                        //         return false;
                                        //     }
                                        // }
                                        if (!item.iGiftNum || item.iGiftNum <= 0) {
                                            cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息第' + itemCount + "行的赠送数量", 'warning');
                                            return false;
                                        }
                                        /**
                                         * 赠送类型    送指定数量赠品  1   送优惠券   2  送积分   3   N倍积分  4    送指定金额赠品5
                                         * 买A赠A特殊： 值为-1
                                         */
                                        if (iGiftType != 4 && (item.iGiftItemType == 1 || item.iGiftItemType == 5)) {
                                            if ((!item.sgiftids || item.sgiftids == '') && (!item.sGiftSkuIds || item.sGiftSkuIds == '')) {
                                                cb.utils.alert('请选择第' + (i + 1) + '组的赠品信息第' + itemCount + "行的赠品", 'warning');
                                                return false;
                                            }
                                        }
                                    }
                                }
                                if (itemCount == 0) {
                                    cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息', 'warning');
                                    return false;
                                }
                            }
                        }
                    }
                    if (obj && obj.giftPreferentialPro) {
                        common.checkDefaultValue(obj.giftPreferentialPro, 'fMarkPrice', 'fSalePrice');
                    }
                    if (obj && obj.giftPreferentialStrategy) {

                        let strategyNew;
                        let bApplyOMCChannel = viewmodel.get('bApplyOMCChannel').getValue();
                        let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                        let applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();

                        for (let i = 0; i < obj.giftPreferentialStrategy.length; i++) {
                            let strategy = obj.giftPreferentialStrategy[i];
                          //设一个初始值
                          strategy['dConsumerSpending'] = strategy['dConsumerSpending']?strategy['dConsumerSpending']:0;
                          strategy['dConsumerSpendingItem'] = strategy['dConsumerSpendingItem']?strategy['dConsumerSpendingItem']:0;
                            if (strategy._status != "Delete") {
                                if (strategy.giftPreferentialItem) {
                                    for (let j = 0; j < strategy.giftPreferentialItem.length; j++) {
                                        let item = strategy.giftPreferentialItem[j];
                                        if (item._status != "Delete") {
                                            if (bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0) {
                                                if (!item.dAvailableNum || item.dAvailableNum == 0) {
                                                    cb.utils.alert('请正确输入第' + (i + 1) + '组的第' + (j + 1) + '行的总可用数量', 'warning');
                                                    return false;
                                                }
                                            }
                                            item.dRemainingAvailableNum = item.dAvailableNum;
                                            //买A赠A
                                            if (iGiftType == 4) {
                                                if (!strategyNew) {
                                                    strategyNew = [];
                                                }
                                                let strategy = {
                                                    "dConsumerSpending": null,
                                                    "dConsumerSpendingItem": 1,
                                                    "giftPreferentialItem": [],
                                                    "id": null,
                                                    "_status": null
                                                };
                                                //孙表状态对应子表状态
                                                item.iGiftItemType = -1;
                                                strategy.id = item.giftPreferentialStrategy;
                                                if (action == 'copy') {
                                                    item["_status"] = 'Insert';
                                                }
                                                strategy._status = item["_status"];
                                                strategy['dConsumerSpending'] = item.iConsumerSpending;
                                                strategy["giftPreferentialItem"].push(item);
                                                strategyNew.push(strategy);
                                            } else {
                                                if (action == 'copy') {
                                                    item._status = "Insert";
                                                } else {
                                                    if (strategy._status == "Update" && item._status == "Unchanged") {
                                                        item._status = "Update";
                                                    }
                                                }
                                                //买就送且非仅勾订单中心将满额条件设置为0
                                                if (iGiftType == 3 && !(bApplyOMCChannel == 1 && applyOnlineChannel == 0 && applyOffLineChannel == 0)) {
                                                    strategy['dConsumerSpending'] = 0;
                                                }
                                                item.iConsumerSpending = strategy['dConsumerSpending'];
                                                /**
                                                 * 赠送类型    送指定数量赠品  1   送优惠券   2  送积分   3   N倍积分  4    送指定金额赠品5
                                                 * 买A赠A特殊： 值为-1
                                                 */
                                                if (item.iGiftItemType == 1 || item.iGiftItemType == 5 || item.iGiftItemType == -1) {
                                                    if (item.sGiftSkuIds && item.sGiftSkuIds != '') {
                                                        item.giftPreferentialItemPro = [];
                                                        let ids = item.sGiftSkuIds.split(',');
                                                        let average = 0;
                                                        let remainder = 0;
                                                        if (strategy.iSendGiftWay == 2) {
                                                            average = parseInt(item.dAvailableNum / item.iGiftNum);
                                                            remainder = item.dAvailableNum - item.iGiftNum * average;
                                                        }
                                                        let sGiftSkunums = "";
                                                        if (item.sGiftSkunums) {
                                                            sGiftSkunums = item.sGiftSkunums.split(',');
                                                        }
                                                        let sGiftSkuAvailableNum = "";
                                                        if (item.sGiftSkuAvailableNum) {
                                                            sGiftSkuAvailableNum = item.sGiftSkuAvailableNum.split(',');
                                                        }
                                                        for (let k = 0; k < ids.length; k++) {
                                                            if (ids[k] != '') {
                                                                let itemPro = {
                                                                    "iProductId": null,
                                                                    "iProductIdType": 1,
                                                                    "iGiftNum": null,
                                                                    "dAvailableNum": null,
                                                                    "dRemainingAvailableNum": null
                                                                };
                                                                itemPro['iProductId'] = ids[k];
                                                                if (strategy.iSendGiftWay == 1) {
                                                                    itemPro['iGiftNum'] = item.iGiftNum;
                                                                    itemPro['dAvailableNum'] = sGiftSkuAvailableNum ? sGiftSkuAvailableNum[k] : 0;
                                                                } else {
                                                                    itemPro['iGiftNum'] = sGiftSkunums ? sGiftSkunums[k] : 0;
                                                                    if (sGiftSkunums) {
                                                                        if (k == 0)
                                                                            itemPro['dAvailableNum'] = average * sGiftSkunums[k] + remainder;
                                                                        else
                                                                            itemPro['dAvailableNum'] = average * sGiftSkunums[k];
                                                                    } else {
                                                                        itemPro['dAvailableNum'] = 0;
                                                                    }
                                                                }
                                                                itemPro['dRemainingAvailableNum'] = itemPro['dAvailableNum'];
                                                                item.giftPreferentialItemPro.push(itemPro);
                                                            }
                                                        }
                                                    }
                                                    if (item.sgiftids && item.sgiftids != '') {
                                                        if (!item.giftPreferentialItemPro) {
                                                            item.giftPreferentialItemPro = [];
                                                        }

                                                        let ids = item.sgiftids.split(',');
                                                        for (let k = 0; k < ids.length; k++) {
                                                            let itemPro = {
                                                                "iProductId": null,
                                                                "iProductIdType": 0
                                                            };
                                                            itemPro['iProductId'] = ids[k];
                                                            item.giftPreferentialItemPro.push(itemPro);
                                                        }
                                                    }
                                                } else if (item.iGiftItemType == 2) {
                                                    if (item.couponids && item.couponids != '') {
                                                        item.giftPreferentialItemCoupon = [];
                                                        let ids = item.couponids.split(',');
                                                        let nums = item.couponnums.split(',');
                                                        for (let k = 0; k < ids.length; k++) {
                                                            if (ids[k] != '') {
                                                                let itemCoupon = {
                                                                    "iCouponId": null,
                                                                    "iCouponNumber": 0
                                                                };
                                                                itemCoupon['iCouponId'] = ids[k];
                                                                itemCoupon['iCouponNumber'] = nums[k];
                                                                item.giftPreferentialItemCoupon.push(itemCoupon);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }else if(iGiftType == 4){
                                            if (!strategyNew) {
                                                strategyNew = [];
                                            }
                                            let strategy = {
                                                "dConsumerSpending": null,
                                                "dConsumerSpendingItem": 1,
                                                "giftPreferentialItem": [],
                                                "id": null,
                                                "_status": null
                                            };
                                            //孙表状态对应子表状态
                                            item.iGiftItemType = -1;
                                            strategy.id = item.giftPreferentialStrategy;
                                            strategy._status = item["_status"];
                                            strategy['dConsumerSpending'] = item.iConsumerSpending;
                                            strategy["giftPreferentialItem"].push(item);
                                            strategyNew.push(strategy);
                                        }
                                    }
                                }
                            }
                        }
                        if (strategyNew && iGiftType == 4) {
                            obj.giftPreferentialStrategy = strategyNew;
                        }
                    }
                }
                if (obj.preferentialShop != null) {
                    for (let i = 0; i < obj.preferentialShop.length; i++) {
                        if (!obj.preferentialShop[i].iType) {
                            obj.preferentialShop[i].iType = 1
                        }
                    }

                }

                data.data.data = JSON.stringify(obj);

            })

            //买家昵称导入
            viewmodel.get('remarkKeywordsImport').on('click', function (params) {

              const url = `/product/nicknameImport?token=${cb.rest.AppContext.token}`;
              //const urln = cb.rest._getUrl(url, null)
              const eleInput = document.createElement('input');
              eleInput.type = 'file';
              eleInput.style.display = 'none';
              eleInput.onchange = function (e) {
                /*const formData = new FormData();
                formData['enctype'] = 'multipart/form-data';
                formData.append('file', e.target.files[0]);
                //cb.utils.alert(`导入中，请稍后`, 'info');
                const xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.send(formData);
                xhr.onreadystatechange = function () {
                  if (xhr.readyState !== 4) return;
                  if (xhr.status === 200) {
                    var ajaxResult = JSON.parse(xhr.responseText);
                    if (ajaxResult.code === 200) {
                        let val = ajaxResult.data;
                        const maxLength = 50000;
                        if(val.length>maxLength){
                          val = val.substr(0,maxLength);
                          viewmodel.get('remarkKeywords').setValue(val);
                          cb.utils.alert(`内容超过`+maxLength+`，自动截断,请检查数据`, 'success');
                        }else{
                          viewmodel.get('remarkKeywords').setValue(val);
                          cb.utils.alert(`成功`,'success');
                        }

                    } else {
                      cb.utils.alert(`模板内容导入失败`, 'error');
                    }
                  }
                };*/
                var bytarr = [];
                var fileObj = e.target.files[0];
                var reader = new FileReader();
                reader.readAsArrayBuffer(fileObj);
                reader.onload = function (e) {
                  //let buffer = e.target.result;
                  var byts = new Uint8Array(this.result);
                  for (var i = 0; i < byts.length; i++) {
                    bytarr.push(byts[i]);
                  }
                  var proxy = cb.rest.DynamicProxy.create({
                    upload: {
                      url: url,
                      method: 'POST'
                    }
                  });

                  var params = {
                      fileStr: Array.prototype.map.call(new Uint8Array(bytarr), x => ('00' + x.toString(16)).slice(-2)).join(''),
                      fileName:fileObj.name
                  }
                  proxy.upload(params, function (err, result) {
                    if (err) {
                      cb.utils.alert(err.message, 'error');
                      return;
                    }
                    if (result) {
                      let val = result;
                      const maxLength = 50000;
                      if(val.length>maxLength){
                        val = val.substr(0,maxLength);
                        viewmodel.get('remarkKeywords').setValue(val);
                        cb.utils.alert(`内容超过`+maxLength+`，自动截断,请检查数据`, 'success');
                      }else{
                        viewmodel.get('remarkKeywords').setValue(val);
                        cb.utils.alert(`成功`,'success');
                      }
                    }
                    //viewmodel.execute('refresh');
                  });
                }
                document.body.removeChild(eleInput);
              };
              document.body.appendChild(eleInput);
              eleInput.click();

            });

            //关键词类型 互斥设置
            viewmodel.get('remarkType').on('afterValueChange',function(args){
                let oldValuesObj = args.oldValue;
                let oldValues = [];
                for(let index in oldValuesObj){
                  let oldValue = oldValuesObj[index].value;
                  oldValues[index] = oldValue;

                }
                let bold3 = false;
                let bnew3 = false;
                if(oldValues.indexOf('3')!=-1){
                  bold3 = true;
                }
                let newValue = viewmodel.get('remarkType').getValue();
                if(newValue.indexOf('3')!=-1){
                  bnew3 = true;
                }
                if((!bold3)&&bnew3){
                  viewmodel.get('remarkType').setValue(['3']);
                  return ;
                } else if(bold3&&bnew3){
                  viewmodel.get('remarkType').setValue([]);
                  let removeIndex = newValue.indexOf('3');
                  newValue.splice(removeIndex, 1);
                  viewmodel.get('remarkType').setValue(newValue);
                  return ;
                }

            });

            //买家昵称导入,模板下载
            viewmodel.get('remarkKeywordsMouldDownload').on('click', function (params) {
              const openUrl = `https://upmallfiles.yonyouup.com/买赠关键词模板.xlsx`;
              if (!openUrl) {
                cb.utils.alert('导出模板的地址为空', 'error');
                return;
              }
              window.open(openUrl);
            });

            const displaySpecifiedAmounts = function (reset) {
                let iGiftType = viewmodel.get("iGiftType").getValue();
                let applyOnlineChannel = common.convertBooleanToInteger(viewmodel.get('applyOnlineChannel').getValue());
                let applyOfflineChannel = common.convertBooleanToInteger(viewmodel.get('applyOffLineChannel').getValue());
                let applyOmcChannel = common.convertBooleanToInteger(viewmodel.get('bApplyOMCChannel').getValue());
                let onlyOffline = (applyOnlineChannel == 0 && applyOfflineChannel == 1 && applyOmcChannel == 0);
                if (onlyOffline) {
                    if (iGiftType == 4 || iGiftType == '4') {
                      viewmodel.get('specifiedAmounts').setVisible(false);
                      if (reset) {
                          viewmodel.get('specifiedAmounts').setValue(false, true);
                      }
                    } else {
                        viewmodel.get('specifiedAmounts').setVisible(true);
                    }
                } else {
                    viewmodel.get('specifiedAmounts').setVisible(false);
                    if (reset) {
                        viewmodel.get('specifiedAmounts').setValue(false, true);
                    }
                }
            }
        }
    };
    try {
        module.exports = PM_pmc_giftpreferential_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_giftpreferential_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_giftpreferential_VM.Extend.js